var items = {
  "block.minecraft.acacia_button": "Nút gỗ xiêm gai",
  "block.minecraft.acacia_door": "Cửa gỗ xiêm gai",
  "block.minecraft.acacia_fence": "Hàng rào gỗ xiêm gai",
  "block.minecraft.acacia_fence_gate": "Cổng rào gỗ xiêm gai",
  "block.minecraft.acacia_hanging_sign": "Tấm biển treo gỗ xiêm gai",
  "block.minecraft.acacia_leaves": "Lá xiêm gai",
  "block.minecraft.acacia_log": "Thân cây xiêm gai",
  "block.minecraft.acacia_planks": "Ván gỗ xiêm gai",
  "block.minecraft.acacia_pressure_plate": "Tấm áp lực gỗ xiêm gai",
  "block.minecraft.acacia_sapling": "Chồi cây xiêm gai",
  "block.minecraft.acacia_shelf": "Kệ gỗ xiêm gai",
  "block.minecraft.acacia_sign": "Tấm biển gỗ xiêm gai",
  "block.minecraft.acacia_slab": "Phiến gỗ xiêm gai",
  "block.minecraft.acacia_stairs": "Cầu thang gỗ xiêm gai",
  "block.minecraft.acacia_trapdoor": "Cửa sập gỗ xiêm gai",
  "block.minecraft.acacia_wall_hanging_sign": "Tấm biển treo gỗ xiêm gai trên tường",
  "block.minecraft.acacia_wall_sign": "Tấm biển gỗ xiêm gai trên tường",
  "block.minecraft.acacia_wood": "Gỗ xiêm gai",
  "block.minecraft.activator_rail": "Đường ray kích hoạt",
  "block.minecraft.air": "Không khí",
  "block.minecraft.allium": "Hành tím",
  "block.minecraft.amethyst_block": "Khối thạch anh tím",
  "block.minecraft.amethyst_cluster": "Cụm thạch anh tím",
  "block.minecraft.ancient_debris": "Mảnh vỡ cổ đại",
  "block.minecraft.andesite": "Đá andesit",
  "block.minecraft.andesite_slab": "Phiến đá andesit",
  "block.minecraft.andesite_stairs": "Cầu thang đá andesit",
  "block.minecraft.andesite_wall": "Tường đá andesit",
  "block.minecraft.anvil": "Cái đe",
  "block.minecraft.attached_melon_stem": "Cuống dưa hấu được gắn",
  "block.minecraft.attached_pumpkin_stem": "Cuống bí ngô được gắn",
  "block.minecraft.azalea": "Đỗ quyên",
  "block.minecraft.azalea_leaves": "Lá đỗ quyên",
  "block.minecraft.azure_bluet": "Thiến thảo xanh",
  "block.minecraft.bamboo": "Cây tre",
  "block.minecraft.bamboo_block": "Khối tre",
  "block.minecraft.bamboo_button": "Nút gỗ tre",
  "block.minecraft.bamboo_door": "Cửa gỗ tre",
  "block.minecraft.bamboo_fence": "Hàng rào gỗ tre",
  "block.minecraft.bamboo_fence_gate": "Cổng rào gỗ tre",
  "block.minecraft.bamboo_hanging_sign": "Tấm biển treo gỗ tre",
  "block.minecraft.bamboo_mosaic": "Khảm tre",
  "block.minecraft.bamboo_mosaic_slab": "Phiến khảm tre",
  "block.minecraft.bamboo_mosaic_stairs": "Cầu thang khảm tre",
  "block.minecraft.bamboo_planks": "Ván gỗ tre",
  "block.minecraft.bamboo_pressure_plate": "Tấm áp lực gỗ tre",
  "block.minecraft.bamboo_sapling": "Măng tre",
  "block.minecraft.bamboo_shelf": "Kệ gỗ tre",
  "block.minecraft.bamboo_sign": "Tấm biển gỗ tre",
  "block.minecraft.bamboo_slab": "Phiến gỗ tre",
  "block.minecraft.bamboo_stairs": "Cầu thang gỗ tre",
  "block.minecraft.bamboo_trapdoor": "Cửa sập gỗ tre",
  "block.minecraft.bamboo_wall_hanging_sign": "Tấm biển treo gỗ tre trên tường",
  "block.minecraft.bamboo_wall_sign": "Tấm biển gỗ tre trên tường",
  "block.minecraft.banner.base.black": "Phủ đen hoàn toàn",
  "block.minecraft.banner.base.blue": "Phủ xanh nước biển hoàn toàn",
  "block.minecraft.banner.base.brown": "Phủ nâu hoàn toàn",
  "block.minecraft.banner.base.cyan": "Phủ lục lam hoàn toàn",
  "block.minecraft.banner.base.gray": "Phủ xám hoàn toàn",
  "block.minecraft.banner.base.green": "Phủ xanh lá hoàn toàn",
  "block.minecraft.banner.base.light_blue": "Phủ xanh nước biển nhạt hoàn toàn",
  "block.minecraft.banner.base.light_gray": "Phủ xám nhạt hoàn toàn",
  "block.minecraft.banner.base.lime": "Phủ xanh lá mạ hoàn toàn",
  "block.minecraft.banner.base.magenta": "Phủ đỏ sậm hoàn toàn",
  "block.minecraft.banner.base.orange": "Phủ cam hoàn toàn",
  "block.minecraft.banner.base.pink": "Phủ hồng hoàn toàn",
  "block.minecraft.banner.base.purple": "Phủ tím hoàn toàn",
  "block.minecraft.banner.base.red": "Phủ đỏ hoàn toàn",
  "block.minecraft.banner.base.white": "Phủ trắng hoàn toàn",
  "block.minecraft.banner.base.yellow": "Phủ vàng hoàn toàn",
  "block.minecraft.banner.border.black": "Đường viền đen",
  "block.minecraft.banner.border.blue": "Đường viền xanh nước biển",
  "block.minecraft.banner.border.brown": "Đường viền nâu",
  "block.minecraft.banner.border.cyan": "Đường viền lục lam",
  "block.minecraft.banner.border.gray": "Đường viền xám",
  "block.minecraft.banner.border.green": "Đường viền xanh lá cây",
  "block.minecraft.banner.border.light_blue": "Đường viền xanh nước biển nhạt",
  "block.minecraft.banner.border.light_gray": "Đường viền xám nhạt",
  "block.minecraft.banner.border.lime": "Đường viền xanh lá mạ",
  "block.minecraft.banner.border.magenta": "Đường viền đỏ sậm",
  "block.minecraft.banner.border.orange": "Đường viền cam",
  "block.minecraft.banner.border.pink": "Đường viền hồng",
  "block.minecraft.banner.border.purple": "Đường viền tím",
  "block.minecraft.banner.border.red": "Đường viền đỏ",
  "block.minecraft.banner.border.white": "Đường viền trắng",
  "block.minecraft.banner.border.yellow": "Đường viền vàng",
  "block.minecraft.banner.bricks.black": "Phủ kín gạch đen",
  "block.minecraft.banner.bricks.blue": "Phủ kín gạch xanh nước biển",
  "block.minecraft.banner.bricks.brown": "Phủ kín gạch nâu",
  "block.minecraft.banner.bricks.cyan": "Phủ kín gạch lục lam",
  "block.minecraft.banner.bricks.gray": "Phủ kín gạch xám",
  "block.minecraft.banner.bricks.green": "Phủ kín gạch xanh lá cây",
  "block.minecraft.banner.bricks.light_blue": "Phủ kín gạch xanh nước biển nhạt",
  "block.minecraft.banner.bricks.light_gray": "Phủ kín gạch xám nhạt",
  "block.minecraft.banner.bricks.lime": "Phủ kín gạch xanh lá mạ",
  "block.minecraft.banner.bricks.magenta": "Phủ kín gạch đỏ sậm",
  "block.minecraft.banner.bricks.orange": "Phủ kín gạch cam",
  "block.minecraft.banner.bricks.pink": "Phủ kín gạch hồng",
  "block.minecraft.banner.bricks.purple": "Phủ kín gạch tím",
  "block.minecraft.banner.bricks.red": "Phủ kín gạch đỏ",
  "block.minecraft.banner.bricks.white": "Phủ kín gạch trắng",
  "block.minecraft.banner.bricks.yellow": "Phủ kín gạch vàng",
  "block.minecraft.banner.circle.black": "Hình tròn đen",
  "block.minecraft.banner.circle.blue": "Hình tròn xanh nước biển",
  "block.minecraft.banner.circle.brown": "Hình tròn nâu",
  "block.minecraft.banner.circle.cyan": "Hình tròn lục lam",
  "block.minecraft.banner.circle.gray": "Hình tròn xám",
  "block.minecraft.banner.circle.green": "Hình tròn xanh lá cây",
  "block.minecraft.banner.circle.light_blue": "Hình tròn xanh nước biển nhạt",
  "block.minecraft.banner.circle.light_gray": "Hình tròn xám nhạt",
  "block.minecraft.banner.circle.lime": "Hình tròn xanh lá mạ",
  "block.minecraft.banner.circle.magenta": "Hình tròn đỏ sậm",
  "block.minecraft.banner.circle.orange": "Hình tròn cam",
  "block.minecraft.banner.circle.pink": "Hình tròn hồng",
  "block.minecraft.banner.circle.purple": "Hình tròn tím",
  "block.minecraft.banner.circle.red": "Hình tròn đỏ",
  "block.minecraft.banner.circle.white": "Hình tròn trắng",
  "block.minecraft.banner.circle.yellow": "Hình tròn vàng",
  "block.minecraft.banner.creeper.black": "Phù hiệu Creeper đen",
  "block.minecraft.banner.creeper.blue": "Phù hiệu Creeper xanh nước biển",
  "block.minecraft.banner.creeper.brown": "Phù hiệu Creeper nâu",
  "block.minecraft.banner.creeper.cyan": "Phù hiệu Creeper lục lam",
  "block.minecraft.banner.creeper.gray": "Phù hiệu Creeper xám",
  "block.minecraft.banner.creeper.green": "Phù hiệu Creeper xanh lá cây",
  "block.minecraft.banner.creeper.light_blue": "Phù hiệu Creeper xanh nước biển nhạt",
  "block.minecraft.banner.creeper.light_gray": "Phù hiệu Creeper xám nhạt",
  "block.minecraft.banner.creeper.lime": "Phù hiệu Creeper xanh lá mạ",
  "block.minecraft.banner.creeper.magenta": "Phù hiệu Creeper đỏ sậm",
  "block.minecraft.banner.creeper.orange": "Phù hiệu Creeper cam",
  "block.minecraft.banner.creeper.pink": "Phù hiệu Creeper hồng",
  "block.minecraft.banner.creeper.purple": "Phù hiệu Creeper tím",
  "block.minecraft.banner.creeper.red": "Phù hiệu Creeper đỏ",
  "block.minecraft.banner.creeper.white": "Phù hiệu Creeper trắng",
  "block.minecraft.banner.creeper.yellow": "Phù hiệu Creeper vàng",
  "block.minecraft.banner.cross.black": "Chữ thập chéo đen",
  "block.minecraft.banner.cross.blue": "Chữ thập chéo xanh nước biển",
  "block.minecraft.banner.cross.brown": "Chữ thập chéo nâu",
  "block.minecraft.banner.cross.cyan": "Chữ thập chéo lục lam",
  "block.minecraft.banner.cross.gray": "Chữ thập chéo xám",
  "block.minecraft.banner.cross.green": "Chữ thập chéo xanh lá cây",
  "block.minecraft.banner.cross.light_blue": "Chữ thập chéo xanh nước biển nhạt",
  "block.minecraft.banner.cross.light_gray": "Chữ thập chéo xám nhạt",
  "block.minecraft.banner.cross.lime": "Chữ thập chéo xanh lá mạ",
  "block.minecraft.banner.cross.magenta": "Chữ thập chéo đỏ sậm",
  "block.minecraft.banner.cross.orange": "Chữ thập chéo cam",
  "block.minecraft.banner.cross.pink": "Chữ thập chéo hồng",
  "block.minecraft.banner.cross.purple": "Chữ thập chéo tím",
  "block.minecraft.banner.cross.red": "Chữ thập chéo đỏ",
  "block.minecraft.banner.cross.white": "Chữ thập chéo trắng",
  "block.minecraft.banner.cross.yellow": "Chữ thập chéo vàng",
  "block.minecraft.banner.curly_border.black": "Đường viền răng cưa đen",
  "block.minecraft.banner.curly_border.blue": "Đường viền răng cưa xanh nước biển",
  "block.minecraft.banner.curly_border.brown": "Đường viền răng cưa nâu",
  "block.minecraft.banner.curly_border.cyan": "Đường viền răng cưa lục lam",
  "block.minecraft.banner.curly_border.gray": "Đường viền răng cưa xám",
  "block.minecraft.banner.curly_border.green": "Đường viền răng cưa xanh lá cây",
  "block.minecraft.banner.curly_border.light_blue": "Đường viền răng cưa xanh nước biển nhạt",
  "block.minecraft.banner.curly_border.light_gray": "Đường viền răng cưa xám nhạt",
  "block.minecraft.banner.curly_border.lime": "Đường viền răng cưa xanh lá mạ",
  "block.minecraft.banner.curly_border.magenta": "Đường viền răng cưa đỏ sậm",
  "block.minecraft.banner.curly_border.orange": "Đường viền răng cưa cam",
  "block.minecraft.banner.curly_border.pink": "Đường viền răng cưa hồng",
  "block.minecraft.banner.curly_border.purple": "Đường viền răng cưa tím",
  "block.minecraft.banner.curly_border.red": "Đường viền răng cưa đỏ",
  "block.minecraft.banner.curly_border.white": "Đường viền răng cưa trắng",
  "block.minecraft.banner.curly_border.yellow": "Đường viền răng cưa vàng",
  "block.minecraft.banner.diagonal_left.black": "Vạch chia chéo ngược đen",
  "block.minecraft.banner.diagonal_left.blue": "Vạch chia chéo ngược xanh nước biển",
  "block.minecraft.banner.diagonal_left.brown": "Vạch chia chéo ngược nâu",
  "block.minecraft.banner.diagonal_left.cyan": "Vạch chia chéo ngược lục lam",
  "block.minecraft.banner.diagonal_left.gray": "Vạch chia chéo ngược xám",
  "block.minecraft.banner.diagonal_left.green": "Vạch chia chéo ngược xanh lá cây",
  "block.minecraft.banner.diagonal_left.light_blue": "Vạch chia chéo ngược xanh nước biển nhạt",
  "block.minecraft.banner.diagonal_left.light_gray": "Vạch chia chéo ngược xám nhạt",
  "block.minecraft.banner.diagonal_left.lime": "Vạch chia chéo ngược xanh lá mạ",
  "block.minecraft.banner.diagonal_left.magenta": "Vạch chia chéo ngược đỏ sậm",
  "block.minecraft.banner.diagonal_left.orange": "Vạch chia chéo ngược cam",
  "block.minecraft.banner.diagonal_left.pink": "Vạch chia chéo ngược hồng",
  "block.minecraft.banner.diagonal_left.purple": "Vạch chia chéo ngược tím",
  "block.minecraft.banner.diagonal_left.red": "Vạch chia chéo ngược đỏ",
  "block.minecraft.banner.diagonal_left.white": "Vạch chia chéo ngược trắng",
  "block.minecraft.banner.diagonal_left.yellow": "Vạch chia chéo ngược vàng",
  "block.minecraft.banner.diagonal_right.black": "Vạch chia chéo đen",
  "block.minecraft.banner.diagonal_right.blue": "Vạch chia chéo xanh nước biển",
  "block.minecraft.banner.diagonal_right.brown": "Vạch chia chéo nâu",
  "block.minecraft.banner.diagonal_right.cyan": "Vạch chia chéo lục lam",
  "block.minecraft.banner.diagonal_right.gray": "Vạch chia chéo xám",
  "block.minecraft.banner.diagonal_right.green": "Vạch chia chéo xanh lá cây",
  "block.minecraft.banner.diagonal_right.light_blue": "Vạch chia chéo xanh nước biển nhạt",
  "block.minecraft.banner.diagonal_right.light_gray": "Vạch chia chéo xám nhạt",
  "block.minecraft.banner.diagonal_right.lime": "Vạch chia chéo xanh lá mạ",
  "block.minecraft.banner.diagonal_right.magenta": "Vạch chia chéo đỏ sậm",
  "block.minecraft.banner.diagonal_right.orange": "Vạch chia chéo cam",
  "block.minecraft.banner.diagonal_right.pink": "Vạch chia chéo hồng",
  "block.minecraft.banner.diagonal_right.purple": "Vạch chia chéo tím",
  "block.minecraft.banner.diagonal_right.red": "Vạch chia chéo đỏ",
  "block.minecraft.banner.diagonal_right.white": "Vạch chia chéo trắng",
  "block.minecraft.banner.diagonal_right.yellow": "Vạch chia chéo vàng",
  "block.minecraft.banner.diagonal_up_left.black": "Vạch chia chéo đảo nghịch đen",
  "block.minecraft.banner.diagonal_up_left.blue": "Vạch chia chéo đảo nghịch xanh nước biển",
  "block.minecraft.banner.diagonal_up_left.brown": "Vạch chia chéo đảo nghịch nâu",
  "block.minecraft.banner.diagonal_up_left.cyan": "Vạch chia chéo đảo nghịch lục lam",
  "block.minecraft.banner.diagonal_up_left.gray": "Vạch chia chéo đảo nghịch xám",
  "block.minecraft.banner.diagonal_up_left.green": "Vạch chia chéo đảo nghịch xanh lá cây",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Vạch chia chéo đảo nghịch xanh nước biển nhạt",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Vạch chia chéo đảo nghịch xám nhạt",
  "block.minecraft.banner.diagonal_up_left.lime": "Vạch chia chéo đảo nghịch xanh lá mạ",
  "block.minecraft.banner.diagonal_up_left.magenta": "Vạch chia chéo đảo nghịch đỏ sậm",
  "block.minecraft.banner.diagonal_up_left.orange": "Vạch chia chéo đảo nghịch cam",
  "block.minecraft.banner.diagonal_up_left.pink": "Vạch chia chéo đảo nghịch hồng",
  "block.minecraft.banner.diagonal_up_left.purple": "Vạch chia chéo đảo nghịch tím",
  "block.minecraft.banner.diagonal_up_left.red": "Vạch chia chéo đảo nghịch đỏ",
  "block.minecraft.banner.diagonal_up_left.white": "Vạch chia chéo đảo nghịch trắng",
  "block.minecraft.banner.diagonal_up_left.yellow": "Vạch chia chéo đảo nghịch vàng",
  "block.minecraft.banner.diagonal_up_right.black": "Vạch chia chéo ngược đảo nghịch đen",
  "block.minecraft.banner.diagonal_up_right.blue": "Vạch chia chéo ngược đảo nghịch xanh nước biển",
  "block.minecraft.banner.diagonal_up_right.brown": "Vạch chia chéo ngược đảo nghịch nâu",
  "block.minecraft.banner.diagonal_up_right.cyan": "Vạch chia chéo ngược đảo nghịch lục lam",
  "block.minecraft.banner.diagonal_up_right.gray": "Vạch chia chéo ngược đảo nghịch xám",
  "block.minecraft.banner.diagonal_up_right.green": "Vạch chia chéo ngược đảo nghịch xanh lá cây",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Vạch chia chéo ngược đảo nghịch xanh nước biển nhạt",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Vạch chia chéo ngược đảo nghịch xám nhạt",
  "block.minecraft.banner.diagonal_up_right.lime": "Vạch chia chéo ngược đảo nghịch xanh lá mạ",
  "block.minecraft.banner.diagonal_up_right.magenta": "Vạch chia chéo ngược đảo nghịch đỏ sậm",
  "block.minecraft.banner.diagonal_up_right.orange": "Vạch chia chéo ngược đảo nghịch cam",
  "block.minecraft.banner.diagonal_up_right.pink": "Vạch chia chéo ngược đảo nghịch hồng",
  "block.minecraft.banner.diagonal_up_right.purple": "Vạch chia chéo ngược đảo nghịch tím",
  "block.minecraft.banner.diagonal_up_right.red": "Vạch chia chéo ngược đảo nghịch đỏ",
  "block.minecraft.banner.diagonal_up_right.white": "Vạch chia chéo ngược đảo nghịch trắng",
  "block.minecraft.banner.diagonal_up_right.yellow": "Vạch chia chéo ngược đảo nghịch vàng",
  "block.minecraft.banner.flow.black": "Làn gió đen",
  "block.minecraft.banner.flow.blue": "Làn gió xanh nước biển",
  "block.minecraft.banner.flow.brown": "Làn gió nâu",
  "block.minecraft.banner.flow.cyan": "Làn gió lục lam",
  "block.minecraft.banner.flow.gray": "Làn gió xám",
  "block.minecraft.banner.flow.green": "Làn gió xanh lá cây",
  "block.minecraft.banner.flow.light_blue": "Làn gió xanh nước biển nhạt",
  "block.minecraft.banner.flow.light_gray": "Làn gió xám nhạt",
  "block.minecraft.banner.flow.lime": "Làn gió xanh lá mạ",
  "block.minecraft.banner.flow.magenta": "Làn gió đỏ sậm",
  "block.minecraft.banner.flow.orange": "Làn gió cam",
  "block.minecraft.banner.flow.pink": "Làn gió hồng",
  "block.minecraft.banner.flow.purple": "Làn gió tím",
  "block.minecraft.banner.flow.red": "Làn gió đỏ",
  "block.minecraft.banner.flow.white": "Làn gió trắng",
  "block.minecraft.banner.flow.yellow": "Làn gió vàng",
  "block.minecraft.banner.flower.black": "Phù hiệu hoa đen",
  "block.minecraft.banner.flower.blue": "Phù hiệu hoa xanh nước biển",
  "block.minecraft.banner.flower.brown": "Phù hiệu hoa nâu",
  "block.minecraft.banner.flower.cyan": "Phù hiệu hoa lục lam",
  "block.minecraft.banner.flower.gray": "Phù hiệu hoa xám",
  "block.minecraft.banner.flower.green": "Phù hiệu hoa xanh lá cây",
  "block.minecraft.banner.flower.light_blue": "Phù hiệu hoa xanh nước biển nhạt",
  "block.minecraft.banner.flower.light_gray": "Phù hiệu hoa xám nhạt",
  "block.minecraft.banner.flower.lime": "Phù hiệu hoa xanh lá mạ",
  "block.minecraft.banner.flower.magenta": "Phù hiệu hoa đỏ sậm",
  "block.minecraft.banner.flower.orange": "Phù hiệu hoa cam",
  "block.minecraft.banner.flower.pink": "Phù hiệu hoa hồng",
  "block.minecraft.banner.flower.purple": "Phù hiệu hoa tím",
  "block.minecraft.banner.flower.red": "Phù hiệu hoa đỏ",
  "block.minecraft.banner.flower.white": "Phù hiệu hoa trắng",
  "block.minecraft.banner.flower.yellow": "Phù hiệu hoa vàng",
  "block.minecraft.banner.globe.black": "Địa cầu đen",
  "block.minecraft.banner.globe.blue": "Địa cầu xanh nước biển",
  "block.minecraft.banner.globe.brown": "Địa cầu nâu",
  "block.minecraft.banner.globe.cyan": "Địa cầu lục lam",
  "block.minecraft.banner.globe.gray": "Địa cầu xám",
  "block.minecraft.banner.globe.green": "Địa cầu xanh lá cây",
  "block.minecraft.banner.globe.light_blue": "Địa cầu xanh nước biển nhạt",
  "block.minecraft.banner.globe.light_gray": "Địa cầu xám nhạt",
  "block.minecraft.banner.globe.lime": "Địa cầu xanh lá mạ",
  "block.minecraft.banner.globe.magenta": "Địa cầu đỏ sậm",
  "block.minecraft.banner.globe.orange": "Địa cầu cam",
  "block.minecraft.banner.globe.pink": "Địa cầu hồng",
  "block.minecraft.banner.globe.purple": "Địa cầu tím",
  "block.minecraft.banner.globe.red": "Địa cầu đỏ",
  "block.minecraft.banner.globe.white": "Địa cầu trắng",
  "block.minecraft.banner.globe.yellow": "Địa cầu vàng",
  "block.minecraft.banner.gradient.black": "Chuyển sắc đen",
  "block.minecraft.banner.gradient.blue": "Chuyển sắc xanh nước biển",
  "block.minecraft.banner.gradient.brown": "Chuyển sắc nâu",
  "block.minecraft.banner.gradient.cyan": "Chuyển sắc lục lam",
  "block.minecraft.banner.gradient.gray": "Chuyển sắc xám",
  "block.minecraft.banner.gradient.green": "Chuyển sắc xanh lá cây",
  "block.minecraft.banner.gradient.light_blue": "Chuyển sắc xanh nước biển nhạt",
  "block.minecraft.banner.gradient.light_gray": "Chuyển sắc xám nhạt",
  "block.minecraft.banner.gradient.lime": "Chuyển sắc xanh lá mạ",
  "block.minecraft.banner.gradient.magenta": "Chuyển sắc đỏ sậm",
  "block.minecraft.banner.gradient.orange": "Chuyển sắc cam",
  "block.minecraft.banner.gradient.pink": "Chuyển sắc hồng",
  "block.minecraft.banner.gradient.purple": "Chuyển sắc tím",
  "block.minecraft.banner.gradient.red": "Chuyển sắc đỏ",
  "block.minecraft.banner.gradient.white": "Chuyển sắc trắng",
  "block.minecraft.banner.gradient.yellow": "Chuyển sắc vàng",
  "block.minecraft.banner.gradient_up.black": "Chuyển sắc đen từ dưới",
  "block.minecraft.banner.gradient_up.blue": "Chuyển sắc xanh nước biển từ dưới",
  "block.minecraft.banner.gradient_up.brown": "Chuyển sắc nâu từ dưới",
  "block.minecraft.banner.gradient_up.cyan": "Chuyển sắc lục lam từ dưới",
  "block.minecraft.banner.gradient_up.gray": "Chuyển sắc xám từ dưới",
  "block.minecraft.banner.gradient_up.green": "Chuyển sắc xanh lá cây từ dưới",
  "block.minecraft.banner.gradient_up.light_blue": "Chuyển sắc xanh nước biển nhạt từ dưới",
  "block.minecraft.banner.gradient_up.light_gray": "Chuyển sắc xám nhạt từ dưới",
  "block.minecraft.banner.gradient_up.lime": "Chuyển sắc xanh lá mạ từ dưới",
  "block.minecraft.banner.gradient_up.magenta": "Chuyển sắc đỏ sậm từ dưới",
  "block.minecraft.banner.gradient_up.orange": "Chuyển sắc cam từ dưới",
  "block.minecraft.banner.gradient_up.pink": "Chuyển sắc hồng từ dưới",
  "block.minecraft.banner.gradient_up.purple": "Chuyển sắc tím từ dưới",
  "block.minecraft.banner.gradient_up.red": "Chuyển sắc đỏ từ dưới",
  "block.minecraft.banner.gradient_up.white": "Chuyển sắc trắng từ dưới",
  "block.minecraft.banner.gradient_up.yellow": "Chuyển sắc vàng từ dưới",
  "block.minecraft.banner.guster.black": "Gió dữ đen",
  "block.minecraft.banner.guster.blue": "Gió dữ xanh nước biển",
  "block.minecraft.banner.guster.brown": "Gió dữ nâu",
  "block.minecraft.banner.guster.cyan": "Gió dữ lục lam",
  "block.minecraft.banner.guster.gray": "Gió dữ xám",
  "block.minecraft.banner.guster.green": "Gió dữ xanh lá cây",
  "block.minecraft.banner.guster.light_blue": "Gió dữ xanh nước biển nhạt",
  "block.minecraft.banner.guster.light_gray": "Gió dữ xám nhạt",
  "block.minecraft.banner.guster.lime": "Gió dữ xanh lá mạ",
  "block.minecraft.banner.guster.magenta": "Gió dữ đỏ sậm",
  "block.minecraft.banner.guster.orange": "Gió dữ cam",
  "block.minecraft.banner.guster.pink": "Gió dữ hồng",
  "block.minecraft.banner.guster.purple": "Gió dữ tím",
  "block.minecraft.banner.guster.red": "Gió dữ đỏ",
  "block.minecraft.banner.guster.white": "Gió dữ trắng",
  "block.minecraft.banner.guster.yellow": "Gió dữ vàng",
  "block.minecraft.banner.half_horizontal.black": "Vạch chia ngang đen",
  "block.minecraft.banner.half_horizontal.blue": "Vạch chia ngang xanh nước biển",
  "block.minecraft.banner.half_horizontal.brown": "Vạch chia ngang nâu",
  "block.minecraft.banner.half_horizontal.cyan": "Vạch chia ngang lục lam",
  "block.minecraft.banner.half_horizontal.gray": "Vạch chia ngang xám",
  "block.minecraft.banner.half_horizontal.green": "Vạch chia ngang xanh lá cây",
  "block.minecraft.banner.half_horizontal.light_blue": "Vạch chia ngang xanh nước biển nhạt",
  "block.minecraft.banner.half_horizontal.light_gray": "Vạch chia ngang xám nhạt",
  "block.minecraft.banner.half_horizontal.lime": "Vạch chia ngang xanh lá mạ",
  "block.minecraft.banner.half_horizontal.magenta": "Vạch chia ngang đỏ sậm",
  "block.minecraft.banner.half_horizontal.orange": "Vạch chia ngang cam",
  "block.minecraft.banner.half_horizontal.pink": "Vạch chia ngang hồng",
  "block.minecraft.banner.half_horizontal.purple": "Vạch chia ngang tím",
  "block.minecraft.banner.half_horizontal.red": "Vạch chia ngang đỏ",
  "block.minecraft.banner.half_horizontal.white": "Vạch chia ngang trắng",
  "block.minecraft.banner.half_horizontal.yellow": "Vạch chia ngang vàng",
  "block.minecraft.banner.half_horizontal_bottom.black": "Vạch chia ngang đảo nghịch đen",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Vạch chia ngang đảo nghịch xanh nước biển",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Vạch chia ngang đảo nghịch nâu",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Vạch chia ngang đảo nghịch lục lam",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Vạch chia ngang đảo nghịch xám",
  "block.minecraft.banner.half_horizontal_bottom.green": "Vạch chia ngang đảo nghịch xanh lá cây",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Vạch chia ngang đảo nghịch xanh nước biển nhạt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Vạch chia ngang đảo nghịch xám nhạt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Vạch chia ngang đảo nghịch xanh lá mạ",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Vạch chia ngang đảo nghịch đỏ sậm",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Vạch chia ngang đảo nghịch cam",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Vạch chia ngang đảo nghịch hồng",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Vạch chia ngang đảo nghịch tím",
  "block.minecraft.banner.half_horizontal_bottom.red": "Vạch chia ngang đảo nghịch đỏ",
  "block.minecraft.banner.half_horizontal_bottom.white": "Vạch chia ngang đảo nghịch trắng",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Vạch chia ngang đảo nghịch vàng",
  "block.minecraft.banner.half_vertical.black": "Vạch cắt dọc màu đen",
  "block.minecraft.banner.half_vertical.blue": "Vạch cắt dọc màu xanh nước biển",
  "block.minecraft.banner.half_vertical.brown": "Vạch cắt dọc màu nâu",
  "block.minecraft.banner.half_vertical.cyan": "Vạch cắt dọc màu lục lam",
  "block.minecraft.banner.half_vertical.gray": "Vạch cắt dọc màu xám",
  "block.minecraft.banner.half_vertical.green": "Vạch cắt dọc màu xanh lá cây",
  "block.minecraft.banner.half_vertical.light_blue": "Vạch cắt dọc màu xanh nước biển nhạt",
  "block.minecraft.banner.half_vertical.light_gray": "Vạch cắt dọc màu xám nhạt",
  "block.minecraft.banner.half_vertical.lime": "Vạch cắt dọc màu xanh lá mạ",
  "block.minecraft.banner.half_vertical.magenta": "Vạch cắt dọc màu đỏ sậm",
  "block.minecraft.banner.half_vertical.orange": "Vạch cắt dọc màu cam",
  "block.minecraft.banner.half_vertical.pink": "Vạch cắt dọc màu hồng",
  "block.minecraft.banner.half_vertical.purple": "Vạch cắt dọc màu tím",
  "block.minecraft.banner.half_vertical.red": "Vạch cắt dọc màu đỏ",
  "block.minecraft.banner.half_vertical.white": "Vạch cắt dọc màu trắng",
  "block.minecraft.banner.half_vertical.yellow": "Vạch cắt dọc màu vàng",
  "block.minecraft.banner.half_vertical_right.black": "Vạch chia dọc đảo nghịch đen",
  "block.minecraft.banner.half_vertical_right.blue": "Vạch chia dọc đảo nghịch xanh nước biển",
  "block.minecraft.banner.half_vertical_right.brown": "Vạch chia dọc đảo nghịch nâu",
  "block.minecraft.banner.half_vertical_right.cyan": "Vạch chia dọc đảo nghịch lục lam",
  "block.minecraft.banner.half_vertical_right.gray": "Vạch chia dọc đảo nghịch xám",
  "block.minecraft.banner.half_vertical_right.green": "Vạch chia dọc đảo nghịch xanh lá cây",
  "block.minecraft.banner.half_vertical_right.light_blue": "Vạch chia dọc đảo nghịch xanh nước biển nhạt",
  "block.minecraft.banner.half_vertical_right.light_gray": "Vạch chia dọc đảo nghịch xám nhạt",
  "block.minecraft.banner.half_vertical_right.lime": "Vạch chia dọc đảo nghịch xanh lá mạ",
  "block.minecraft.banner.half_vertical_right.magenta": "Vạch chia dọc đảo nghịch đỏ sậm",
  "block.minecraft.banner.half_vertical_right.orange": "Vạch chia dọc đảo nghịch cam",
  "block.minecraft.banner.half_vertical_right.pink": "Vạch chia dọc đảo nghịch hồng",
  "block.minecraft.banner.half_vertical_right.purple": "Vạch chia dọc đảo nghịch tím",
  "block.minecraft.banner.half_vertical_right.red": "Vạch chia dọc đảo nghịch đỏ",
  "block.minecraft.banner.half_vertical_right.white": "Vạch chia dọc đảo nghịch trắng",
  "block.minecraft.banner.half_vertical_right.yellow": "Vạch chia dọc đảo nghịch vàng",
  "block.minecraft.banner.mojang.black": "Vật thể đen",
  "block.minecraft.banner.mojang.blue": "Vật thể xanh nước biển",
  "block.minecraft.banner.mojang.brown": "Vật thể nâu",
  "block.minecraft.banner.mojang.cyan": "Vật thể lục lam",
  "block.minecraft.banner.mojang.gray": "Vật thể xám",
  "block.minecraft.banner.mojang.green": "Vật thể xanh lá cây",
  "block.minecraft.banner.mojang.light_blue": "Vật thể xanh nước biển nhạt",
  "block.minecraft.banner.mojang.light_gray": "Vật thể xám nhạt",
  "block.minecraft.banner.mojang.lime": "Vật thể xanh lá mạ",
  "block.minecraft.banner.mojang.magenta": "Vật thể đỏ sậm",
  "block.minecraft.banner.mojang.orange": "Vật thể cam",
  "block.minecraft.banner.mojang.pink": "Vật thể hồng",
  "block.minecraft.banner.mojang.purple": "Vật thể tím",
  "block.minecraft.banner.mojang.red": "Vật thể đỏ",
  "block.minecraft.banner.mojang.white": "Vật thể trắng",
  "block.minecraft.banner.mojang.yellow": "Vật thể vàng",
  "block.minecraft.banner.piglin.black": "Mũi heo đen",
  "block.minecraft.banner.piglin.blue": "Mũi heo xanh nước biển",
  "block.minecraft.banner.piglin.brown": "Mũi heo nâu",
  "block.minecraft.banner.piglin.cyan": "Mũi heo lục lam",
  "block.minecraft.banner.piglin.gray": "Mũi heo xám",
  "block.minecraft.banner.piglin.green": "Mũi heo xanh lá cây",
  "block.minecraft.banner.piglin.light_blue": "Mũi heo xanh nước biển nhạt",
  "block.minecraft.banner.piglin.light_gray": "Mũi heo xám nhạt",
  "block.minecraft.banner.piglin.lime": "Mũi heo xanh lá mạ",
  "block.minecraft.banner.piglin.magenta": "Mũi heo đỏ sậm",
  "block.minecraft.banner.piglin.orange": "Mũi heo cam",
  "block.minecraft.banner.piglin.pink": "Mũi heo hồng",
  "block.minecraft.banner.piglin.purple": "Mũi heo tím",
  "block.minecraft.banner.piglin.red": "Mũi heo đỏ",
  "block.minecraft.banner.piglin.white": "Mũi heo trắng",
  "block.minecraft.banner.piglin.yellow": "Mũi heo vàng",
  "block.minecraft.banner.rhombus.black": "Hình thoi đen",
  "block.minecraft.banner.rhombus.blue": "Hình thoi xanh nước biển",
  "block.minecraft.banner.rhombus.brown": "Hình thoi nâu",
  "block.minecraft.banner.rhombus.cyan": "Hình thoi lục lam",
  "block.minecraft.banner.rhombus.gray": "Hình thoi xám",
  "block.minecraft.banner.rhombus.green": "Hình thoi xanh lá cây",
  "block.minecraft.banner.rhombus.light_blue": "Hình thoi xanh nước biển nhạt",
  "block.minecraft.banner.rhombus.light_gray": "Hình thoi xám nhạt",
  "block.minecraft.banner.rhombus.lime": "Hình thoi xanh lá mạ",
  "block.minecraft.banner.rhombus.magenta": "Hình thoi đỏ sậm",
  "block.minecraft.banner.rhombus.orange": "Hình thoi cam",
  "block.minecraft.banner.rhombus.pink": "Hình thoi hồng",
  "block.minecraft.banner.rhombus.purple": "Hình thoi tím",
  "block.minecraft.banner.rhombus.red": "Hình thoi đỏ",
  "block.minecraft.banner.rhombus.white": "Hình thoi trắng",
  "block.minecraft.banner.rhombus.yellow": "Hình thoi vàng",
  "block.minecraft.banner.skull.black": "Phù hiệu đầu lâu đen",
  "block.minecraft.banner.skull.blue": "Phù hiệu đầu lâu xanh nước biển",
  "block.minecraft.banner.skull.brown": "Phù hiệu đầu lâu nâu",
  "block.minecraft.banner.skull.cyan": "Phù hiệu đầu lâu lục lam",
  "block.minecraft.banner.skull.gray": "Phù hiệu đầu lâu xám",
  "block.minecraft.banner.skull.green": "Phù hiệu đầu lâu xanh lá cây",
  "block.minecraft.banner.skull.light_blue": "Phù hiệu đầu lâu xanh nước biển nhạt",
  "block.minecraft.banner.skull.light_gray": "Phù hiệu đầu lâu xám nhạt",
  "block.minecraft.banner.skull.lime": "Phù hiệu đầu lâu xanh lá mạ",
  "block.minecraft.banner.skull.magenta": "Phù hiệu đầu lâu đỏ sậm",
  "block.minecraft.banner.skull.orange": "Phù hiệu đầu lâu cam",
  "block.minecraft.banner.skull.pink": "Phù hiệu đầu lâu hồng",
  "block.minecraft.banner.skull.purple": "Phù hiệu đầu lâu tím",
  "block.minecraft.banner.skull.red": "Phù hiệu đầu lâu đỏ",
  "block.minecraft.banner.skull.white": "Phù hiệu đầu lâu trắng",
  "block.minecraft.banner.skull.yellow": "Phù hiệu đầu lâu vàng",
  "block.minecraft.banner.small_stripes.black": "Vạch dọc đen nhỏ",
  "block.minecraft.banner.small_stripes.blue": "Vạch dọc xanh nước biển nhỏ",
  "block.minecraft.banner.small_stripes.brown": "Vạch dọc nâu nhỏ",
  "block.minecraft.banner.small_stripes.cyan": "Vạch dọc lục lam nhỏ",
  "block.minecraft.banner.small_stripes.gray": "Vạch dọc xám nhỏ",
  "block.minecraft.banner.small_stripes.green": "Vạch dọc xanh lá cây nhỏ",
  "block.minecraft.banner.small_stripes.light_blue": "Vạch dọc xanh nước biển nhạt nhỏ",
  "block.minecraft.banner.small_stripes.light_gray": "Vạch dọc xám nhạt nhỏ",
  "block.minecraft.banner.small_stripes.lime": "Vạch dọc xanh lá mạ nhỏ",
  "block.minecraft.banner.small_stripes.magenta": "Vạch dọc đỏ sậm nhỏ",
  "block.minecraft.banner.small_stripes.orange": "Vạch dọc cam nhỏ",
  "block.minecraft.banner.small_stripes.pink": "Vạch dọc hồng nhỏ",
  "block.minecraft.banner.small_stripes.purple": "Vạch dọc tím nhỏ",
  "block.minecraft.banner.small_stripes.red": "Vạch dọc đỏ nhỏ",
  "block.minecraft.banner.small_stripes.white": "Vạch dọc trắng nhỏ",
  "block.minecraft.banner.small_stripes.yellow": "Vạch dọc vàng nhỏ",
  "block.minecraft.banner.square_bottom_left.black": "Ô vuông đen ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.blue": "Ô vuông xanh nước biển ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.brown": "Ô vuông nâu ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.cyan": "Ô vuông lục lam ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.gray": "Ô vuông xám ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.green": "Ô vuông xanh lá cây ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ô vuông xanh nước biển nhạt ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ô vuông xám nhạt ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.lime": "Ô vuông xanh lá mạ ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.magenta": "Ô vuông đỏ sậm ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.orange": "Ô vuông cam ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.pink": "Ô vuông hồng ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.purple": "Ô vuông tím ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.red": "Ô vuông đỏ ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.white": "Ô vuông trắng ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_left.yellow": "Ô vuông vàng ở góc dưới bên trái",
  "block.minecraft.banner.square_bottom_right.black": "Ô vuông đen ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.blue": "Ô vuông xanh nước biển ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.brown": "Ô vuông nâu ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.cyan": "Ô vuông lục lam ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.gray": "Ô vuông xám ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.green": "Ô vuông xanh lá cây ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ô vuông xanh nước biển nhạt ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ô vuông xám nhạt ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.lime": "Ô vuông xanh lá mạ ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.magenta": "Ô vuông đỏ sậm ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.orange": "Ô vuông cam ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.pink": "Ô vuông hồng ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.purple": "Ô vuông tím ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.red": "Ô vuông đỏ ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.white": "Ô vuông trắng ở góc dưới bên phải",
  "block.minecraft.banner.square_bottom_right.yellow": "Ô vuông vàng ở góc dưới bên phải",
  "block.minecraft.banner.square_top_left.black": "Ô vuông đen ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.blue": "Ô vuông xanh nước biển ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.brown": "Ô vuông nâu ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.cyan": "Ô vuông lục lam ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.gray": "Ô vuông xám ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.green": "Ô vuông xanh lá cây ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.light_blue": "Ô vuông xanh nước biển nhạt ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.light_gray": "Ô vuông xám nhạt ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.lime": "Ô vuông xanh lá mạ ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.magenta": "Ô vuông đỏ sậm ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.orange": "Ô vuông cam ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.pink": "Ô vuông hồng ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.purple": "Ô vuông tím ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.red": "Ô vuông đỏ ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.white": "Ô vuông trắng ở góc trên bên trái",
  "block.minecraft.banner.square_top_left.yellow": "Ô vuông vàng ở góc trên bên trái",
  "block.minecraft.banner.square_top_right.black": "Ô vuông đen ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.blue": "Ô vuông xanh nước biển ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.brown": "Ô vuông nâu ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.cyan": "Ô vuông lục lam ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.gray": "Ô vuông xám ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.green": "Ô vuông xanh lá cây ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.light_blue": "Ô vuông xanh nước biển nhạt ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.light_gray": "Ô vuông xám nhạt ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.lime": "Ô vuông xanh lá mạ ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.magenta": "Ô vuông đỏ sậm ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.orange": "Ô vuông cam ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.pink": "Ô vuông hồng ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.purple": "Ô vuông tím ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.red": "Ô vuông đỏ ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.white": "Ô vuông trắng ở góc trên bên phải",
  "block.minecraft.banner.square_top_right.yellow": "Ô vuông vàng ở góc trên bên phải",
  "block.minecraft.banner.straight_cross.black": "Chữ thập đen",
  "block.minecraft.banner.straight_cross.blue": "Chữ thập xanh nước biển",
  "block.minecraft.banner.straight_cross.brown": "Chữ thập nâu",
  "block.minecraft.banner.straight_cross.cyan": "Chữ thập lục lam",
  "block.minecraft.banner.straight_cross.gray": "Chữ thập xám",
  "block.minecraft.banner.straight_cross.green": "Chữ thập xanh lá cây",
  "block.minecraft.banner.straight_cross.light_blue": "Chữ thập xanh nước biển nhạt",
  "block.minecraft.banner.straight_cross.light_gray": "Chữ thập xám nhạt",
  "block.minecraft.banner.straight_cross.lime": "Chữ thập xanh lá mạ",
  "block.minecraft.banner.straight_cross.magenta": "Chữ thập đỏ sậm",
  "block.minecraft.banner.straight_cross.orange": "Chữ thập cam",
  "block.minecraft.banner.straight_cross.pink": "Chữ thập hồng",
  "block.minecraft.banner.straight_cross.purple": "Chữ thập tím",
  "block.minecraft.banner.straight_cross.red": "Chữ thập đỏ",
  "block.minecraft.banner.straight_cross.white": "Chữ thập trắng",
  "block.minecraft.banner.straight_cross.yellow": "Chữ thập vàng",
  "block.minecraft.banner.stripe_bottom.black": "Ô vuông đen ở góc dưới",
  "block.minecraft.banner.stripe_bottom.blue": "Ô vuông xanh nước biển ở góc dưới",
  "block.minecraft.banner.stripe_bottom.brown": "Ô vuông nâu ở góc dưới",
  "block.minecraft.banner.stripe_bottom.cyan": "Ô vuông lục lam ở góc dưới",
  "block.minecraft.banner.stripe_bottom.gray": "Ô vuông xám ở góc dưới",
  "block.minecraft.banner.stripe_bottom.green": "Ô vuông xanh lá cây ở góc dưới",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ô vuông xanh nước biển nhạt ở góc dưới",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ô vuông xám nhạt ở góc dưới",
  "block.minecraft.banner.stripe_bottom.lime": "Ô vuông xanh lá mạ ở góc dưới",
  "block.minecraft.banner.stripe_bottom.magenta": "Ô vuông đỏ sậm ở góc dưới",
  "block.minecraft.banner.stripe_bottom.orange": "Ô vuông cam ở góc dưới",
  "block.minecraft.banner.stripe_bottom.pink": "Ô vuông hồng ở góc dưới",
  "block.minecraft.banner.stripe_bottom.purple": "Ô vuông tím ở góc dưới",
  "block.minecraft.banner.stripe_bottom.red": "Ô vuông đỏ ở góc dưới",
  "block.minecraft.banner.stripe_bottom.white": "Ô vuông trắng ở góc dưới",
  "block.minecraft.banner.stripe_bottom.yellow": "Ô vuông vàng ở góc dưới",
  "block.minecraft.banner.stripe_center.black": "Vạch dọc đen",
  "block.minecraft.banner.stripe_center.blue": "Vạch dọc xanh nước biển",
  "block.minecraft.banner.stripe_center.brown": "Vạch dọc nâu",
  "block.minecraft.banner.stripe_center.cyan": "Vạch dọc lục lam",
  "block.minecraft.banner.stripe_center.gray": "Vạch dọc xám",
  "block.minecraft.banner.stripe_center.green": "Vạch dọc xanh lá cây",
  "block.minecraft.banner.stripe_center.light_blue": "Vạch dọc xanh nước biển nhạt",
  "block.minecraft.banner.stripe_center.light_gray": "Vạch dọc xám nhạt",
  "block.minecraft.banner.stripe_center.lime": "Vạch dọc xanh lá mạ",
  "block.minecraft.banner.stripe_center.magenta": "Vạch dọc đỏ sậm",
  "block.minecraft.banner.stripe_center.orange": "Vạch dọc cam",
  "block.minecraft.banner.stripe_center.pink": "Vạch dọc hồng",
  "block.minecraft.banner.stripe_center.purple": "Vạch dọc tím",
  "block.minecraft.banner.stripe_center.red": "Vạch dọc đỏ",
  "block.minecraft.banner.stripe_center.white": "Vạch dọc trắng",
  "block.minecraft.banner.stripe_center.yellow": "Vạch dọc vàng",
  "block.minecraft.banner.stripe_downleft.black": "Vạch chéo ngược đen",
  "block.minecraft.banner.stripe_downleft.blue": "Vạch chéo ngược xanh nước biển",
  "block.minecraft.banner.stripe_downleft.brown": "Vạch chéo ngược nâu",
  "block.minecraft.banner.stripe_downleft.cyan": "Vạch chéo ngược lục lam",
  "block.minecraft.banner.stripe_downleft.gray": "Vạch chéo ngược xám",
  "block.minecraft.banner.stripe_downleft.green": "Vạch chéo ngược xanh lá cây",
  "block.minecraft.banner.stripe_downleft.light_blue": "Vạch chéo ngược xanh nước biển nhạt",
  "block.minecraft.banner.stripe_downleft.light_gray": "Vạch chéo ngược xám nhạt",
  "block.minecraft.banner.stripe_downleft.lime": "Vạch chéo ngược xanh lá mạ",
  "block.minecraft.banner.stripe_downleft.magenta": "Vạch chéo ngược đỏ sậm",
  "block.minecraft.banner.stripe_downleft.orange": "Vạch chéo ngược cam",
  "block.minecraft.banner.stripe_downleft.pink": "Vạch chéo ngược hồng",
  "block.minecraft.banner.stripe_downleft.purple": "Vạch chéo ngược tím",
  "block.minecraft.banner.stripe_downleft.red": "Vạch chéo ngược đỏ",
  "block.minecraft.banner.stripe_downleft.white": "Vạch chéo ngược trắng",
  "block.minecraft.banner.stripe_downleft.yellow": "Vạch chéo ngược vàng",
  "block.minecraft.banner.stripe_downright.black": "Vạch chéo đen",
  "block.minecraft.banner.stripe_downright.blue": "Vạch chéo xanh nước biển",
  "block.minecraft.banner.stripe_downright.brown": "Vạch chéo nâu",
  "block.minecraft.banner.stripe_downright.cyan": "Vạch chéo lục lam",
  "block.minecraft.banner.stripe_downright.gray": "Vạch chéo xám",
  "block.minecraft.banner.stripe_downright.green": "Vạch chéo xanh lá cây",
  "block.minecraft.banner.stripe_downright.light_blue": "Vạch chéo xanh nước biển nhạt",
  "block.minecraft.banner.stripe_downright.light_gray": "Vạch chéo xám nhạt",
  "block.minecraft.banner.stripe_downright.lime": "Vạch chéo xanh lá mạ",
  "block.minecraft.banner.stripe_downright.magenta": "Vạch chéo đỏ sậm",
  "block.minecraft.banner.stripe_downright.orange": "Vạch chéo cam",
  "block.minecraft.banner.stripe_downright.pink": "Vạch chéo hồng",
  "block.minecraft.banner.stripe_downright.purple": "Vạch chéo tím",
  "block.minecraft.banner.stripe_downright.red": "Vạch chéo đỏ",
  "block.minecraft.banner.stripe_downright.white": "Vạch chéo trắng",
  "block.minecraft.banner.stripe_downright.yellow": "Vạch chéo vàng",
  "block.minecraft.banner.stripe_left.black": "Vạch dọc đen ở góc trái",
  "block.minecraft.banner.stripe_left.blue": "Vạch dọc xanh nước biển ở góc trái",
  "block.minecraft.banner.stripe_left.brown": "Vạch dọc nâu ở góc trái",
  "block.minecraft.banner.stripe_left.cyan": "Vạch dọc lục lam ở góc trái",
  "block.minecraft.banner.stripe_left.gray": "Vạch dọc xám ở góc trái",
  "block.minecraft.banner.stripe_left.green": "Vạch dọc xanh lá cây ở góc trái",
  "block.minecraft.banner.stripe_left.light_blue": "Vạch dọc xanh nước biển nhạt ở bên trái",
  "block.minecraft.banner.stripe_left.light_gray": "Vạch dọc xám nhạt ở góc trái",
  "block.minecraft.banner.stripe_left.lime": "Vạch dọc xanh lá mạ ở bên trái",
  "block.minecraft.banner.stripe_left.magenta": "Vạch dọc đỏ sậm ở bên trái",
  "block.minecraft.banner.stripe_left.orange": "Vạch dọc cam ở bên trái",
  "block.minecraft.banner.stripe_left.pink": "Vạch dọc hồng ở bên trái",
  "block.minecraft.banner.stripe_left.purple": "Vạch dọc tím ở góc trái",
  "block.minecraft.banner.stripe_left.red": "Vạch dọc đỏ ở góc trái",
  "block.minecraft.banner.stripe_left.white": "Vạch dọc trắng ở bên trái",
  "block.minecraft.banner.stripe_left.yellow": "Vạch dọc vàng ở bên trái",
  "block.minecraft.banner.stripe_middle.black": "Vạch ngang đen",
  "block.minecraft.banner.stripe_middle.blue": "Vạch ngang xanh nước biển",
  "block.minecraft.banner.stripe_middle.brown": "Vạch ngang dọc nâu",
  "block.minecraft.banner.stripe_middle.cyan": "Vạch ngang lục lam",
  "block.minecraft.banner.stripe_middle.gray": "Vạch ngang xám",
  "block.minecraft.banner.stripe_middle.green": "Vạch ngang xanh lá cây",
  "block.minecraft.banner.stripe_middle.light_blue": "Vạch ngang xanh nước biển nhạt",
  "block.minecraft.banner.stripe_middle.light_gray": "Vạch ngang xám nhạt",
  "block.minecraft.banner.stripe_middle.lime": "Vạch ngang xanh lá mạ",
  "block.minecraft.banner.stripe_middle.magenta": "Vạch ngang đỏ sậm",
  "block.minecraft.banner.stripe_middle.orange": "Vạch ngang cam",
  "block.minecraft.banner.stripe_middle.pink": "Vạch ngang hồng",
  "block.minecraft.banner.stripe_middle.purple": "Vạch ngang tím",
  "block.minecraft.banner.stripe_middle.red": "Vạch ngang đỏ",
  "block.minecraft.banner.stripe_middle.white": "Vạch ngang trắng",
  "block.minecraft.banner.stripe_middle.yellow": "Vạch ngang vàng",
  "block.minecraft.banner.stripe_right.black": "Vạch dọc đen ở bên phải",
  "block.minecraft.banner.stripe_right.blue": "Vạch dọc xanh nước biển ở bên phải",
  "block.minecraft.banner.stripe_right.brown": "Vạch dọc nâu ở bên phải",
  "block.minecraft.banner.stripe_right.cyan": "Vạch dọc lục lam ở bên phải",
  "block.minecraft.banner.stripe_right.gray": "Vạch dọc xám ở bên phải",
  "block.minecraft.banner.stripe_right.green": "Vạch dọc xanh lá cây ở bên phải",
  "block.minecraft.banner.stripe_right.light_blue": "Vạch dọc xanh nước biển nhạt ở bên phải",
  "block.minecraft.banner.stripe_right.light_gray": "Vạch dọc xám nhạt ở bên phải",
  "block.minecraft.banner.stripe_right.lime": "Vạch dọc xanh lá mạ ở bên phải",
  "block.minecraft.banner.stripe_right.magenta": "Vạch dọc đỏ sậm ở bên phải",
  "block.minecraft.banner.stripe_right.orange": "Vạch dọc cam ở bên phải",
  "block.minecraft.banner.stripe_right.pink": "Vạch dọc hồng ở bên phải",
  "block.minecraft.banner.stripe_right.purple": "Vạch dọc tím ở bên phải",
  "block.minecraft.banner.stripe_right.red": "Vạch dọc đỏ ở bên phải",
  "block.minecraft.banner.stripe_right.white": "Vạch dọc trắng ở bên phải",
  "block.minecraft.banner.stripe_right.yellow": "Vạch dọc vàng ở bên phải",
  "block.minecraft.banner.stripe_top.black": "Ô vuông đen ở góc trên",
  "block.minecraft.banner.stripe_top.blue": "Ô vuông xanh nước biển ở góc trên",
  "block.minecraft.banner.stripe_top.brown": "Ô vuông nâu ở góc trên",
  "block.minecraft.banner.stripe_top.cyan": "Ô vuông lục lam ở góc trên",
  "block.minecraft.banner.stripe_top.gray": "Ô vuông xám ở góc trên",
  "block.minecraft.banner.stripe_top.green": "Ô vuông xanh lá cây ở góc trên",
  "block.minecraft.banner.stripe_top.light_blue": "Ô vuông xanh nước biển nhạt ở góc trên",
  "block.minecraft.banner.stripe_top.light_gray": "Ô vuông xám nhạt ở góc trên",
  "block.minecraft.banner.stripe_top.lime": "Ô vuông xanh lá mạ ở góc trên",
  "block.minecraft.banner.stripe_top.magenta": "Ô vuông đỏ sậm ở góc trên",
  "block.minecraft.banner.stripe_top.orange": "Ô vuông cam ở góc trên",
  "block.minecraft.banner.stripe_top.pink": "Ô vuông hồng ở góc trên",
  "block.minecraft.banner.stripe_top.purple": "Ô vuông tím ở góc trên",
  "block.minecraft.banner.stripe_top.red": "Ô vuông đỏ ở góc trên",
  "block.minecraft.banner.stripe_top.white": "Ô vuông trắng ở góc trên",
  "block.minecraft.banner.stripe_top.yellow": "Ô vuông vàng ở góc trên",
  "block.minecraft.banner.triangle_bottom.black": "Tam giác đen ở góc dưới",
  "block.minecraft.banner.triangle_bottom.blue": "Tam giác xanh nước biển ở góc dưới",
  "block.minecraft.banner.triangle_bottom.brown": "Tam giác nâu ở góc dưới",
  "block.minecraft.banner.triangle_bottom.cyan": "Tam giác lục lam ở góc dưới",
  "block.minecraft.banner.triangle_bottom.gray": "Tam giác xám ở góc dưới",
  "block.minecraft.banner.triangle_bottom.green": "Tam giác xanh lá cây ở góc dưới",
  "block.minecraft.banner.triangle_bottom.light_blue": "Tam giác xanh nước biển nhạt ở góc dưới",
  "block.minecraft.banner.triangle_bottom.light_gray": "Tam giác xám nhạt ở góc dưới",
  "block.minecraft.banner.triangle_bottom.lime": "Tam giác xanh lá mạ ở góc dưới",
  "block.minecraft.banner.triangle_bottom.magenta": "Tam giác đỏ sậm ở góc dưới",
  "block.minecraft.banner.triangle_bottom.orange": "Tam giác cam ở góc dưới",
  "block.minecraft.banner.triangle_bottom.pink": "Tam giác hồng ở góc dưới",
  "block.minecraft.banner.triangle_bottom.purple": "Tam giác tím ở góc dưới",
  "block.minecraft.banner.triangle_bottom.red": "Tam giác đỏ ở góc dưới",
  "block.minecraft.banner.triangle_bottom.white": "Tam giác trắng ở góc dưới",
  "block.minecraft.banner.triangle_bottom.yellow": "Tam giác vàng ở góc dưới",
  "block.minecraft.banner.triangle_top.black": "Tam giác đen ở góc trên",
  "block.minecraft.banner.triangle_top.blue": "Tam giác xanh nước biển ở góc trên",
  "block.minecraft.banner.triangle_top.brown": "Tam giác nâu ở góc trên",
  "block.minecraft.banner.triangle_top.cyan": "Tam giác lục lam ở góc trên",
  "block.minecraft.banner.triangle_top.gray": "Tam giác xám ở góc trên",
  "block.minecraft.banner.triangle_top.green": "Tam giác xanh lá cây ở góc trên",
  "block.minecraft.banner.triangle_top.light_blue": "Tam giác xanh nước biển nhạt ở góc trên",
  "block.minecraft.banner.triangle_top.light_gray": "Tam giác xám nhạt ở góc trên",
  "block.minecraft.banner.triangle_top.lime": "Tam giác xanh lá mạ ở góc trên",
  "block.minecraft.banner.triangle_top.magenta": "Tam giác đỏ sậm ở góc trên",
  "block.minecraft.banner.triangle_top.orange": "Tam giác cam ở góc trên",
  "block.minecraft.banner.triangle_top.pink": "Tam giác hồng ở góc trên",
  "block.minecraft.banner.triangle_top.purple": "Tam giác tím ở góc trên",
  "block.minecraft.banner.triangle_top.red": "Tam giác đỏ ở góc trên",
  "block.minecraft.banner.triangle_top.white": "Tam giác trắng ở góc trên",
  "block.minecraft.banner.triangle_top.yellow": "Tam giác vàng ở góc trên",
  "block.minecraft.banner.triangles_bottom.black": "Hình răng cưa màu đen ở góc dưới",
  "block.minecraft.banner.triangles_bottom.blue": "Hình răng cưa màu xanh nước biển ở góc dưới",
  "block.minecraft.banner.triangles_bottom.brown": "Hình răng cưa màu nâu ở góc dưới",
  "block.minecraft.banner.triangles_bottom.cyan": "Hình răng cưa màu lục lam ở góc dưới",
  "block.minecraft.banner.triangles_bottom.gray": "Hình răng cưa màu xám ở góc dưới",
  "block.minecraft.banner.triangles_bottom.green": "Hình răng cưa màu xanh lá cây ở góc dưới",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hình răng cưa màu xanh nước biển nhạt ở góc dưới",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hình răng cưa màu xám nhạt ở góc dưới",
  "block.minecraft.banner.triangles_bottom.lime": "Hình răng cưa màu xanh lá mạ ở góc dưới",
  "block.minecraft.banner.triangles_bottom.magenta": "Hình răng cưa màu đỏ sậm ở góc dưới",
  "block.minecraft.banner.triangles_bottom.orange": "Hình răng cưa màu cam ở góc dưới",
  "block.minecraft.banner.triangles_bottom.pink": "Hình răng cưa màu hồng ở góc dưới",
  "block.minecraft.banner.triangles_bottom.purple": "Hình răng cưa màu tím ở góc dưới",
  "block.minecraft.banner.triangles_bottom.red": "Hình răng cưa màu đỏ ở góc dưới",
  "block.minecraft.banner.triangles_bottom.white": "Hình răng cưa màu trắng ở góc dưới",
  "block.minecraft.banner.triangles_bottom.yellow": "Hình răng cưa màu vàng ở góc dưới",
  "block.minecraft.banner.triangles_top.black": "Hình răng cưa màu đen ở góc trên",
  "block.minecraft.banner.triangles_top.blue": "Hình răng cưa màu xanh nước biển ở góc trên",
  "block.minecraft.banner.triangles_top.brown": "Hình răng cưa màu nâu ở góc trên",
  "block.minecraft.banner.triangles_top.cyan": "Hình răng cưa màu lục lam ở góc trên",
  "block.minecraft.banner.triangles_top.gray": "Hình răng cưa màu xám ở góc trên",
  "block.minecraft.banner.triangles_top.green": "Hình răng cưa màu xanh lá cây ở góc trên",
  "block.minecraft.banner.triangles_top.light_blue": "Hình răng cưa màu xanh nước biển nhạt ở góc trên",
  "block.minecraft.banner.triangles_top.light_gray": "Hình răng cưa màu xám nhạt ở góc trên",
  "block.minecraft.banner.triangles_top.lime": "Hình răng cưa màu xanh lá mạ ở góc trên",
  "block.minecraft.banner.triangles_top.magenta": "Hình răng cưa màu đỏ sậm ở góc trên",
  "block.minecraft.banner.triangles_top.orange": "Hình răng cưa màu cam ở góc trên",
  "block.minecraft.banner.triangles_top.pink": "Hình răng cưa màu hồng ở góc trên",
  "block.minecraft.banner.triangles_top.purple": "Hình răng cưa màu tím ở góc trên",
  "block.minecraft.banner.triangles_top.red": "Hình răng cưa màu đỏ ở góc trên",
  "block.minecraft.banner.triangles_top.white": "Hình răng cưa màu trắng ở góc trên",
  "block.minecraft.banner.triangles_top.yellow": "Hình răng cưa màu vàng ở góc trên",
  "block.minecraft.barrel": "Thùng",
  "block.minecraft.barrier": "Rào chắn",
  "block.minecraft.basalt": "Đá bazan",
  "block.minecraft.beacon": "Đèn hiệu",
  "block.minecraft.beacon.primary": "Năng lượng chính",
  "block.minecraft.beacon.secondary": "Năng lượng phụ",
  "block.minecraft.bed.no_sleep": "Bạn chỉ có thể ngủ vào buổi tối hoặc khi trời mưa bão",
  "block.minecraft.bed.not_safe": "Bạn chưa thể nghỉ ngơi ngay được; có quái vật đang gần đó",
  "block.minecraft.bed.obstructed": "Giường này đã bị chiếm",
  "block.minecraft.bed.occupied": "Giường đã có người nằm",
  "block.minecraft.bed.too_far_away": "Bạn chưa thể nghỉ ngơi ngay được; giường ở quá xa",
  "block.minecraft.bedrock": "Đá nền",
  "block.minecraft.bee_nest": "Tổ ong tự nhiên",
  "block.minecraft.beehive": "Tổ ong nhân tạo",
  "block.minecraft.beetroots": "Củ dền",
  "block.minecraft.bell": "Chuông",
  "block.minecraft.big_dripleaf": "Lá nhỏ giọt lớn",
  "block.minecraft.big_dripleaf_stem": "Cuống lá nhỏ giọt lớn",
  "block.minecraft.birch_button": "Nút gỗ bạch dương",
  "block.minecraft.birch_door": "Cửa gỗ bạch dương",
  "block.minecraft.birch_fence": "Hàng rào gỗ bạch dương",
  "block.minecraft.birch_fence_gate": "Cổng rào gỗ bạch dương",
  "block.minecraft.birch_hanging_sign": "Tấm biển treo gỗ bạch dương",
  "block.minecraft.birch_leaves": "Lá bạch dương",
  "block.minecraft.birch_log": "Thân cây bạch dương",
  "block.minecraft.birch_planks": "Ván gỗ bạch dương",
  "block.minecraft.birch_pressure_plate": "Tấm áp lực gỗ bạch dương",
  "block.minecraft.birch_sapling": "Chồi cây bạch dương",
  "block.minecraft.birch_shelf": "Kệ gỗ bạch dương",
  "block.minecraft.birch_sign": "Tấm biển gỗ bạch dương",
  "block.minecraft.birch_slab": "Phiến gỗ bạch dương",
  "block.minecraft.birch_stairs": "Cầu thang gỗ bạch dương",
  "block.minecraft.birch_trapdoor": "Cửa sập gỗ bạch dương",
  "block.minecraft.birch_wall_hanging_sign": "Tấm biển treo gỗ bạch dương trên tường",
  "block.minecraft.birch_wall_sign": "Tấm biển gỗ bạch dương trên tường",
  "block.minecraft.birch_wood": "Gỗ bạch dương",
  "block.minecraft.black_banner": "Cờ hiệu đen",
  "block.minecraft.black_bed": "Giường đen",
  "block.minecraft.black_candle": "Nến đen",
  "block.minecraft.black_candle_cake": "Bánh ngọt có nến đen",
  "block.minecraft.black_carpet": "Thảm đen",
  "block.minecraft.black_concrete": "Bê tông đen",
  "block.minecraft.black_concrete_powder": "Bột bê tông đen",
  "block.minecraft.black_glazed_terracotta": "Đất nung tráng men đen",
  "block.minecraft.black_shulker_box": "Hộp Shulker đen",
  "block.minecraft.black_stained_glass": "Thủy tinh được nhuộm đen",
  "block.minecraft.black_stained_glass_pane": "Tấm thủy tinh được nhuộm đen",
  "block.minecraft.black_terracotta": "Đất nung đen",
  "block.minecraft.black_wool": "Len đen",
  "block.minecraft.blackstone": "Đá đen",
  "block.minecraft.blackstone_slab": "Phiến đá đen",
  "block.minecraft.blackstone_stairs": "Cầu thang đá đen",
  "block.minecraft.blackstone_wall": "Tường đá đen",
  "block.minecraft.blast_furnace": "Lò luyện kim",
  "block.minecraft.blue_banner": "Cờ hiệu xanh nước biển",
  "block.minecraft.blue_bed": "Giường xanh nước biển",
  "block.minecraft.blue_candle": "Nến xanh nước biển",
  "block.minecraft.blue_candle_cake": "Bánh ngọt có nến xanh nước biển",
  "block.minecraft.blue_carpet": "Thảm xanh nước biển",
  "block.minecraft.blue_concrete": "Bê tông xanh nước biển",
  "block.minecraft.blue_concrete_powder": "Bột bê tông xanh nước biển",
  "block.minecraft.blue_glazed_terracotta": "Đất nung tráng men xanh nước biển",
  "block.minecraft.blue_ice": "Băng xanh",
  "block.minecraft.blue_orchid": "Phong lan xanh",
  "block.minecraft.blue_shulker_box": "Hộp Shulker xanh nước biển",
  "block.minecraft.blue_stained_glass": "Thủy tinh được nhuộm xanh nước biển",
  "block.minecraft.blue_stained_glass_pane": "Tấm thủy tinh được nhuộm xanh nước biển",
  "block.minecraft.blue_terracotta": "Đất nung xanh nước biển",
  "block.minecraft.blue_wool": "Len xanh nước biển",
  "block.minecraft.bone_block": "Khối xương",
  "block.minecraft.bookshelf": "Kệ sách",
  "block.minecraft.brain_coral": "San hô não",
  "block.minecraft.brain_coral_block": "Khối san hô não",
  "block.minecraft.brain_coral_fan": "San hô não hình quạt",
  "block.minecraft.brain_coral_wall_fan": "Cành san hô não hình quạt",
  "block.minecraft.brewing_stand": "Giàn pha thuốc",
  "block.minecraft.brick_slab": "Phiến gạch",
  "block.minecraft.brick_stairs": "Cầu thang gạch",
  "block.minecraft.brick_wall": "Tường gạch",
  "block.minecraft.bricks": "Gạch",
  "block.minecraft.brown_banner": "Cờ hiệu nâu",
  "block.minecraft.brown_bed": "Giường nâu",
  "block.minecraft.brown_candle": "Nến nâu",
  "block.minecraft.brown_candle_cake": "Bánh ngọt có nến nâu",
  "block.minecraft.brown_carpet": "Thảm nâu",
  "block.minecraft.brown_concrete": "Bê tông nâu",
  "block.minecraft.brown_concrete_powder": "Bột bê tông nâu",
  "block.minecraft.brown_glazed_terracotta": "Đất nung tráng men nâu",
  "block.minecraft.brown_mushroom": "Nấm nâu",
  "block.minecraft.brown_mushroom_block": "Khối nấm nâu",
  "block.minecraft.brown_shulker_box": "Hộp Shulker nâu",
  "block.minecraft.brown_stained_glass": "Thủy tinh được nhuộm nâu",
  "block.minecraft.brown_stained_glass_pane": "Tấm thủy tinh được nhuộm nâu",
  "block.minecraft.brown_terracotta": "Đất nung nâu",
  "block.minecraft.brown_wool": "Len nâu",
  "block.minecraft.bubble_column": "Cột bong bóng",
  "block.minecraft.bubble_coral": "San hô bong bóng",
  "block.minecraft.bubble_coral_block": "Khối san hô bong bóng",
  "block.minecraft.bubble_coral_fan": "San hô bong bóng hình quạt",
  "block.minecraft.bubble_coral_wall_fan": "Cành san hô bong bóng hình quạt",
  "block.minecraft.budding_amethyst": "Nụ thạch anh tím",
  "block.minecraft.bush": "Bụi cây",
  "block.minecraft.cactus": "Xương rồng",
  "block.minecraft.cactus_flower": "Hoa xương rồng",
  "block.minecraft.cake": "Bánh ngọt",
  "block.minecraft.calcite": "Calcit",
  "block.minecraft.calibrated_sculk_sensor": "Cảm biến Sculk được hiệu chỉnh",
  "block.minecraft.campfire": "Lửa trại",
  "block.minecraft.candle": "Nến",
  "block.minecraft.candle_cake": "Bánh ngọt có nến",
  "block.minecraft.carrots": "Cà rốt",
  "block.minecraft.cartography_table": "Bàn vẽ bản đồ",
  "block.minecraft.carved_pumpkin": "Bí ngô được khắc",
  "block.minecraft.cauldron": "Vạc",
  "block.minecraft.cave_air": "Không khí hang động",
  "block.minecraft.cave_vines": "Dây leo hang động",
  "block.minecraft.cave_vines_plant": "Cây dây leo hang động",
  "block.minecraft.chain": "Dây xích",
  "block.minecraft.chain_command_block": "Khối lệnh liền chuỗi",
  "block.minecraft.cherry_button": "Nút gỗ anh đào",
  "block.minecraft.cherry_door": "Cửa gỗ anh đào",
  "block.minecraft.cherry_fence": "Hàng rào gỗ anh đào",
  "block.minecraft.cherry_fence_gate": "Cổng rào gỗ anh đào",
  "block.minecraft.cherry_hanging_sign": "Tấm biển treo gỗ anh đào",
  "block.minecraft.cherry_leaves": "Lá anh đào",
  "block.minecraft.cherry_log": "Thân cây anh đào",
  "block.minecraft.cherry_planks": "Ván gỗ anh đào",
  "block.minecraft.cherry_pressure_plate": "Tấm áp lực gỗ anh đào",
  "block.minecraft.cherry_sapling": "Chồi cây anh đào",
  "block.minecraft.cherry_shelf": "Kệ gỗ anh đào",
  "block.minecraft.cherry_sign": "Tấm biển gỗ anh đào",
  "block.minecraft.cherry_slab": "Phiến gỗ anh đào",
  "block.minecraft.cherry_stairs": "Cầu thang gỗ anh đào",
  "block.minecraft.cherry_trapdoor": "Cửa sập gỗ anh đào",
  "block.minecraft.cherry_wall_hanging_sign": "Tấm biển treo gỗ anh đào trên tường",
  "block.minecraft.cherry_wall_sign": "Tấm biển gỗ anh đào trên tường",
  "block.minecraft.cherry_wood": "Gỗ anh đào",
  "block.minecraft.chest": "Rương",
  "block.minecraft.chipped_anvil": "Cái đe bị nứt",
  "block.minecraft.chiseled_bookshelf": "Kệ sách được đục",
  "block.minecraft.chiseled_copper": "Khối đồng được đục",
  "block.minecraft.chiseled_deepslate": "Đá bảng sâu được đục",
  "block.minecraft.chiseled_nether_bricks": "Gạch Nether được đục",
  "block.minecraft.chiseled_polished_blackstone": "Đá đen được đánh bóng được đục",
  "block.minecraft.chiseled_quartz_block": "Khối thạch anh được đục",
  "block.minecraft.chiseled_red_sandstone": "Cát kết đỏ được đục",
  "block.minecraft.chiseled_resin_bricks": "Gạch nhựa cây được đục",
  "block.minecraft.chiseled_sandstone": "Cát kết được đục",
  "block.minecraft.chiseled_stone_bricks": "Gạch đá được đục",
  "block.minecraft.chiseled_tuff": "Đá túp được đục",
  "block.minecraft.chiseled_tuff_bricks": "Gạch đá túp được đục",
  "block.minecraft.chorus_flower": "Hoa Chorus",
  "block.minecraft.chorus_plant": "Cây Chorus",
  "block.minecraft.clay": "Đất sét",
  "block.minecraft.closed_eyeblossom": "Hoa mắt nhắm",
  "block.minecraft.coal_block": "Khối than",
  "block.minecraft.coal_ore": "Quặng than",
  "block.minecraft.coarse_dirt": "Đất thô",
  "block.minecraft.cobbled_deepslate": "Đá cuội bảng sâu",
  "block.minecraft.cobbled_deepslate_slab": "Phiến đá cuội bảng sâu",
  "block.minecraft.cobbled_deepslate_stairs": "Cầu thang đá cuội bảng sâu",
  "block.minecraft.cobbled_deepslate_wall": "Tường đá cuội bảng sâu",
  "block.minecraft.cobblestone": "Đá cuội",
  "block.minecraft.cobblestone_slab": "Phiến đá cuội",
  "block.minecraft.cobblestone_stairs": "Cầu thang đá cuội",
  "block.minecraft.cobblestone_wall": "Tường đá cuội",
  "block.minecraft.cobweb": "Mạng nhện",
  "block.minecraft.cocoa": "Ca cao",
  "block.minecraft.command_block": "Khối lệnh",
  "block.minecraft.comparator": "Mạch so sánh Redstone",
  "block.minecraft.composter": "Thùng ủ phân",
  "block.minecraft.conduit": "Ống dẫn",
  "block.minecraft.copper_bars": "Hàng rào đồng",
  "block.minecraft.copper_block": "Khối đồng",
  "block.minecraft.copper_bulb": "Bóng đèn đồng",
  "block.minecraft.copper_chain": "Dây xích đồng",
  "block.minecraft.copper_chest": "Rương đồng",
  "block.minecraft.copper_door": "Cửa đồng",
  "block.minecraft.copper_golem_statue": "Tượng người đồng",
  "block.minecraft.copper_grate": "Lưới đồng",
  "block.minecraft.copper_lantern": "Đèn lồng đồng",
  "block.minecraft.copper_ore": "Quặng đồng",
  "block.minecraft.copper_torch": "Đuốc đồng",
  "block.minecraft.copper_trapdoor": "Cửa sập đồng",
  "block.minecraft.copper_wall_torch": "Đuốc đồng trên tường",
  "block.minecraft.cornflower": "Thanh cúc",
  "block.minecraft.cracked_deepslate_bricks": "Gạch đá bảng sâu nứt",
  "block.minecraft.cracked_deepslate_tiles": "Đá lát bảng sâu nứt",
  "block.minecraft.cracked_nether_bricks": "Gạch Nether nứt",
  "block.minecraft.cracked_polished_blackstone_bricks": "Gạch đá đen được đánh bóng nứt",
  "block.minecraft.cracked_stone_bricks": "Gạch đá nứt",
  "block.minecraft.crafter": "Máy chế tạo",
  "block.minecraft.crafting_table": "Bàn chế tạo",
  "block.minecraft.creaking_heart": "Trái tim Quái cọt kẹt",
  "block.minecraft.creeper_head": "Đầu Creeper",
  "block.minecraft.creeper_wall_head": "Đầu Creeper trên tường",
  "block.minecraft.crimson_button": "Nút đỏ thẫm",
  "block.minecraft.crimson_door": "Cửa đỏ thẫm",
  "block.minecraft.crimson_fence": "Hàng rào đỏ thẫm",
  "block.minecraft.crimson_fence_gate": "Cổng rào đỏ thẫm",
  "block.minecraft.crimson_fungus": "Nấm đỏ thẫm",
  "block.minecraft.crimson_hanging_sign": "Tấm biển treo đỏ thẫm",
  "block.minecraft.crimson_hyphae": "Sợi nấm đỏ thẫm",
  "block.minecraft.crimson_nylium": "Khuẩn dị thể đỏ thẫm",
  "block.minecraft.crimson_planks": "Ván đỏ thẫm",
  "block.minecraft.crimson_pressure_plate": "Tấm áp lực đỏ thẫm",
  "block.minecraft.crimson_roots": "Rễ đỏ thẫm",
  "block.minecraft.crimson_shelf": "Kệ đỏ thẫm",
  "block.minecraft.crimson_sign": "Tấm biển đỏ thẫm",
  "block.minecraft.crimson_slab": "Phiến đỏ thẫm",
  "block.minecraft.crimson_stairs": "Cầu thang đỏ thẫm",
  "block.minecraft.crimson_stem": "Cuống đỏ thẫm",
  "block.minecraft.crimson_trapdoor": "Cửa sập đỏ thẫm",
  "block.minecraft.crimson_wall_hanging_sign": "Tấm biển treo đỏ thẫm trên tường",
  "block.minecraft.crimson_wall_sign": "Tấm biển đỏ thẫm trên tường",
  "block.minecraft.crying_obsidian": "Hắc diện thạch khóc",
  "block.minecraft.cut_copper": "Khối đồng được cắt",
  "block.minecraft.cut_copper_slab": "Phiến đồng được cắt",
  "block.minecraft.cut_copper_stairs": "Cầu thang đồng được cắt",
  "block.minecraft.cut_red_sandstone": "Cát kết đỏ được cắt",
  "block.minecraft.cut_red_sandstone_slab": "Phiến cát kết đỏ được cắt",
  "block.minecraft.cut_sandstone": "Cát kết được cắt",
  "block.minecraft.cut_sandstone_slab": "Phiến cát kết được cắt",
  "block.minecraft.cyan_banner": "Cờ hiệu lục lam",
  "block.minecraft.cyan_bed": "Giường lục lam",
  "block.minecraft.cyan_candle": "Nến lục lam",
  "block.minecraft.cyan_candle_cake": "Bánh ngọt có nến lục lam",
  "block.minecraft.cyan_carpet": "Thảm lục lam",
  "block.minecraft.cyan_concrete": "Bê tông lục lam",
  "block.minecraft.cyan_concrete_powder": "Bột bê tông lục lam",
  "block.minecraft.cyan_glazed_terracotta": "Đất nung tráng men lục lam",
  "block.minecraft.cyan_shulker_box": "Hộp Shulker lục lam",
  "block.minecraft.cyan_stained_glass": "Thủy tinh được nhuộm lục lam",
  "block.minecraft.cyan_stained_glass_pane": "Tấm thủy tinh được nhuộm lục lam",
  "block.minecraft.cyan_terracotta": "Đất nung lục lam",
  "block.minecraft.cyan_wool": "Len lục lam",
  "block.minecraft.damaged_anvil": "Cái đe bị hỏng",
  "block.minecraft.dandelion": "Bồ công anh",
  "block.minecraft.dark_oak_button": "Nút gỗ sồi sẫm",
  "block.minecraft.dark_oak_door": "Cửa gỗ sồi sẫm",
  "block.minecraft.dark_oak_fence": "Hàng rào gỗ sồi sẫm",
  "block.minecraft.dark_oak_fence_gate": "Cổng rào gỗ sồi sẫm",
  "block.minecraft.dark_oak_hanging_sign": "Tấm biển treo gỗ sồi sẫm",
  "block.minecraft.dark_oak_leaves": "Lá sồi sẫm",
  "block.minecraft.dark_oak_log": "Thân cây sồi sẫm",
  "block.minecraft.dark_oak_planks": "Ván gỗ sồi sẫm",
  "block.minecraft.dark_oak_pressure_plate": "Tấm áp lực gỗ sồi sẫm",
  "block.minecraft.dark_oak_sapling": "Chồi cây sồi sẫm",
  "block.minecraft.dark_oak_shelf": "Kệ gỗ sồi sẫm",
  "block.minecraft.dark_oak_sign": "Tấm biển gỗ sồi sẫm",
  "block.minecraft.dark_oak_slab": "Phiến gỗ sồi sẫm",
  "block.minecraft.dark_oak_stairs": "Cầu thang gỗ sồi sẫm",
  "block.minecraft.dark_oak_trapdoor": "Cửa sập gỗ sồi sẫm",
  "block.minecraft.dark_oak_wall_hanging_sign": "Tấm biển treo gỗ sồi sẫm trên tường",
  "block.minecraft.dark_oak_wall_sign": "Tấm biển gỗ sồi sẫm trên tường",
  "block.minecraft.dark_oak_wood": "Gỗ sồi sẫm",
  "block.minecraft.dark_prismarine": "Prismarin sẫm màu",
  "block.minecraft.dark_prismarine_slab": "Phiến Prismarin sẫm màu",
  "block.minecraft.dark_prismarine_stairs": "Cầu thang Prismarin sẫm màu",
  "block.minecraft.daylight_detector": "Máy dò ánh sáng",
  "block.minecraft.dead_brain_coral": "San hô não chết",
  "block.minecraft.dead_brain_coral_block": "Khối san hô não chết",
  "block.minecraft.dead_brain_coral_fan": "San hô não hình quạt chết",
  "block.minecraft.dead_brain_coral_wall_fan": "Cành san hô não hình quạt chết",
  "block.minecraft.dead_bubble_coral": "San hô bong bóng chết",
  "block.minecraft.dead_bubble_coral_block": "Khối san hô bong bóng chết",
  "block.minecraft.dead_bubble_coral_fan": "San hô bong bóng hình quạt chết",
  "block.minecraft.dead_bubble_coral_wall_fan": "Cành san hô bong bóng hình quạt chết",
  "block.minecraft.dead_bush": "Bụi cây khô",
  "block.minecraft.dead_fire_coral": "San hô lửa chết",
  "block.minecraft.dead_fire_coral_block": "Khối san hô lửa chết",
  "block.minecraft.dead_fire_coral_fan": "San hô lửa hình quạt chết",
  "block.minecraft.dead_fire_coral_wall_fan": "Cành san hô lửa hình quạt chết",
  "block.minecraft.dead_horn_coral": "San hô sừng chết",
  "block.minecraft.dead_horn_coral_block": "Khối san hô sừng chết",
  "block.minecraft.dead_horn_coral_fan": "San hô sừng hình quạt chết",
  "block.minecraft.dead_horn_coral_wall_fan": "Cành san hô sừng hình quạt chết",
  "block.minecraft.dead_tube_coral": "San hô ống tròn chết",
  "block.minecraft.dead_tube_coral_block": "Khối san hô ống tròn chết",
  "block.minecraft.dead_tube_coral_fan": "San hô ống tròn hình quạt chết",
  "block.minecraft.dead_tube_coral_wall_fan": "Cành san hô ống tròn hình quạt chết",
  "block.minecraft.decorated_pot": "Chậu trang trí",
  "block.minecraft.deepslate": "Đá bảng sâu",
  "block.minecraft.deepslate_brick_slab": "Phiến gạch đá bảng sâu",
  "block.minecraft.deepslate_brick_stairs": "Cầu thang gạch đá bảng sâu",
  "block.minecraft.deepslate_brick_wall": "Tường gạch đá bảng sâu",
  "block.minecraft.deepslate_bricks": "Gạch đá bảng sâu",
  "block.minecraft.deepslate_coal_ore": "Quặng than đá bảng sâu",
  "block.minecraft.deepslate_copper_ore": "Quặng đồng đá bảng sâu",
  "block.minecraft.deepslate_diamond_ore": "Quặng kim cương đá bảng sâu",
  "block.minecraft.deepslate_emerald_ore": "Quặng ngọc lục bảo đá bảng sâu",
  "block.minecraft.deepslate_gold_ore": "Quặng vàng đá bảng sâu",
  "block.minecraft.deepslate_iron_ore": "Quặng sắt đá bảng sâu",
  "block.minecraft.deepslate_lapis_ore": "Quặng ngọc lưu ly đá bảng sâu",
  "block.minecraft.deepslate_redstone_ore": "Quặng Redstone đá bảng sâu",
  "block.minecraft.deepslate_tile_slab": "Phiến đá lát bảng sâu",
  "block.minecraft.deepslate_tile_stairs": "Cầu thang đá lát bảng sâu",
  "block.minecraft.deepslate_tile_wall": "Tường đá lát bảng sâu",
  "block.minecraft.deepslate_tiles": "Đá lát bảng sâu",
  "block.minecraft.detector_rail": "Đường ray cảm biến",
  "block.minecraft.diamond_block": "Khối kim cương",
  "block.minecraft.diamond_ore": "Quặng kim cương",
  "block.minecraft.diorite": "Đá diorit",
  "block.minecraft.diorite_slab": "Phiến đá diorit",
  "block.minecraft.diorite_stairs": "Cầu thang đá diorit",
  "block.minecraft.diorite_wall": "Tường đá diorit",
  "block.minecraft.dirt": "Đất",
  "block.minecraft.dirt_path": "Đường đất",
  "block.minecraft.dispenser": "Máy phân phát",
  "block.minecraft.dragon_egg": "Trứng rồng",
  "block.minecraft.dragon_head": "Đầu rồng",
  "block.minecraft.dragon_wall_head": "Đầu rồng trên tường",
  "block.minecraft.dried_ghast": "Ghast khô",
  "block.minecraft.dried_kelp_block": "Khối tảo bẹ khô",
  "block.minecraft.dripstone_block": "Khối thạch nhũ",
  "block.minecraft.dropper": "Máy thả",
  "block.minecraft.emerald_block": "Khối ngọc lục bảo",
  "block.minecraft.emerald_ore": "Quặng ngọc lục bảo",
  "block.minecraft.enchanting_table": "Bàn phù phép",
  "block.minecraft.end_gateway": "Cổng nối End",
  "block.minecraft.end_portal": "Cổng End",
  "block.minecraft.end_portal_frame": "Khung cổng End",
  "block.minecraft.end_rod": "Thanh gậy End",
  "block.minecraft.end_stone": "Đá End",
  "block.minecraft.end_stone_brick_slab": "Phiến gạch đá End",
  "block.minecraft.end_stone_brick_stairs": "Cầu thang gạch đá End",
  "block.minecraft.end_stone_brick_wall": "Tường gạch đá End",
  "block.minecraft.end_stone_bricks": "Gạch đá End",
  "block.minecraft.ender_chest": "Rương Ender",
  "block.minecraft.exposed_chiseled_copper": "Khối đồng được đục bị phơi ra",
  "block.minecraft.exposed_copper": "Khối đồng bị phơi ra",
  "block.minecraft.exposed_copper_bars": "Hàng rào đồng bị phơi ra",
  "block.minecraft.exposed_copper_bulb": "Bóng đèn đồng bị phơi ra",
  "block.minecraft.exposed_copper_chain": "Dây xích đồng bị phơi ra",
  "block.minecraft.exposed_copper_chest": "Rương đồng bị phơi ra",
  "block.minecraft.exposed_copper_door": "Cửa đồng bị phơi ra",
  "block.minecraft.exposed_copper_golem_statue": "Tượng người đồng bị phơi ra",
  "block.minecraft.exposed_copper_grate": "Lưới đồng bị phơi ra",
  "block.minecraft.exposed_copper_lantern": "Đèn lồng đồng bị phơi ra",
  "block.minecraft.exposed_copper_trapdoor": "Cửa sập đồng bị phơi ra",
  "block.minecraft.exposed_cut_copper": "Khối đồng được cắt bị phơi ra",
  "block.minecraft.exposed_cut_copper_slab": "Phiến đồng được cắt bị phơi ra",
  "block.minecraft.exposed_cut_copper_stairs": "Cầu thang đồng được cắt bị phơi ra",
  "block.minecraft.exposed_lightning_rod": "Cột thu lôi bị phơi ra",
  "block.minecraft.farmland": "Đất ruộng",
  "block.minecraft.fern": "Dương xỉ",
  "block.minecraft.fire": "Lửa",
  "block.minecraft.fire_coral": "San hô lửa",
  "block.minecraft.fire_coral_block": "Khối san hô lửa",
  "block.minecraft.fire_coral_fan": "San hô lửa hình quạt",
  "block.minecraft.fire_coral_wall_fan": "Cành san hô lửa hình quạt",
  "block.minecraft.firefly_bush": "Bụi đom đóm",
  "block.minecraft.fletching_table": "Bàn làm cung tên",
  "block.minecraft.flower_pot": "Chậu hoa",
  "block.minecraft.flowering_azalea": "Đỗ quyên đang trổ bông",
  "block.minecraft.flowering_azalea_leaves": "Lá đỗ quyên có hoa",
  "block.minecraft.frogspawn": "Trứng ếch",
  "block.minecraft.frosted_ice": "Băng phủ sương",
  "block.minecraft.furnace": "Lò nung",
  "block.minecraft.gilded_blackstone": "Đá đen mạ vàng",
  "block.minecraft.glass": "Thủy tinh",
  "block.minecraft.glass_pane": "Tấm thủy tinh",
  "block.minecraft.glow_lichen": "Địa y phát sáng",
  "block.minecraft.glowstone": "Đá phát sáng",
  "block.minecraft.gold_block": "Khối vàng",
  "block.minecraft.gold_ore": "Quặng vàng",
  "block.minecraft.golden_dandelion": "Bồ công anh vàng",
  "block.minecraft.granite": "Đá hoa cương",
  "block.minecraft.granite_slab": "Phiến đá hoa cương",
  "block.minecraft.granite_stairs": "Cầu thang đá hoa cương",
  "block.minecraft.granite_wall": "Tường đá hoa cương",
  "block.minecraft.grass": "Cỏ",
  "block.minecraft.grass_block": "Khối cỏ",
  "block.minecraft.gravel": "Sỏi",
  "block.minecraft.gray_banner": "Cờ hiệu xám",
  "block.minecraft.gray_bed": "Giường xám",
  "block.minecraft.gray_candle": "Nến xám",
  "block.minecraft.gray_candle_cake": "Bánh ngọt có nến xám",
  "block.minecraft.gray_carpet": "Thảm xám",
  "block.minecraft.gray_concrete": "Bê tông xám",
  "block.minecraft.gray_concrete_powder": "Bột bê tông xám",
  "block.minecraft.gray_glazed_terracotta": "Đất nung tráng men xám",
  "block.minecraft.gray_shulker_box": "Hộp Shulker xám",
  "block.minecraft.gray_stained_glass": "Thủy tinh được nhuộm xám",
  "block.minecraft.gray_stained_glass_pane": "Tấm thủy tinh được nhuộm xám",
  "block.minecraft.gray_terracotta": "Đất nung xám",
  "block.minecraft.gray_wool": "Len xám",
  "block.minecraft.green_banner": "Cờ hiệu xanh lá cây",
  "block.minecraft.green_bed": "Giường xanh lá cây",
  "block.minecraft.green_candle": "Nến xanh lá cây",
  "block.minecraft.green_candle_cake": "Bánh ngọt có nến xanh lá cây",
  "block.minecraft.green_carpet": "Thảm xanh lá cây",
  "block.minecraft.green_concrete": "Bê tông xanh lá cây",
  "block.minecraft.green_concrete_powder": "Bột bê tông xanh lá cây",
  "block.minecraft.green_glazed_terracotta": "Đất nung tráng men xanh lá cây",
  "block.minecraft.green_shulker_box": "Hộp Shulker xanh lá cây",
  "block.minecraft.green_stained_glass": "Thủy tinh được nhuộm xanh lá cây",
  "block.minecraft.green_stained_glass_pane": "Tấm thủy tinh được nhuộm xanh lá cây",
  "block.minecraft.green_terracotta": "Đất nung xanh lá cây",
  "block.minecraft.green_wool": "Len xanh lá cây",
  "block.minecraft.grindstone": "Đá mài",
  "block.minecraft.hanging_roots": "Rễ treo",
  "block.minecraft.hay_block": "Kiện rơm",
  "block.minecraft.heavy_core": "Lõi nặng",
  "block.minecraft.heavy_weighted_pressure_plate": "Tấm áp lực nặng",
  "block.minecraft.honey_block": "Khối mật ong",
  "block.minecraft.honeycomb_block": "Khối sáp ong",
  "block.minecraft.hopper": "Cái phễu",
  "block.minecraft.horn_coral": "San hô sừng",
  "block.minecraft.horn_coral_block": "Khối san hô sừng",
  "block.minecraft.horn_coral_fan": "San hô sừng hình quạt",
  "block.minecraft.horn_coral_wall_fan": "Cành san hô sừng hình quạt",
  "block.minecraft.ice": "Băng",
  "block.minecraft.infested_chiseled_stone_bricks": "Gạch đá được đục bị nhiễm khuẩn",
  "block.minecraft.infested_cobblestone": "Đá cuội bị nhiễm khuẩn",
  "block.minecraft.infested_cracked_stone_bricks": "Gạch đá nứt bị nhiễm khuẩn",
  "block.minecraft.infested_deepslate": "Đá bảng sâu bị nhiễm khuẩn",
  "block.minecraft.infested_mossy_stone_bricks": "Gạch đá phủ rêu bị nhiễm khuẩn",
  "block.minecraft.infested_stone": "Đá bị nhiễm khuẩn",
  "block.minecraft.infested_stone_bricks": "Gạch đá bị nhiễm khuẩn",
  "block.minecraft.iron_bars": "Hàng rào sắt",
  "block.minecraft.iron_block": "Khối sắt",
  "block.minecraft.iron_chain": "Dây xích sắt",
  "block.minecraft.iron_door": "Cửa sắt",
  "block.minecraft.iron_ore": "Quặng sắt",
  "block.minecraft.iron_trapdoor": "Cửa sập sắt",
  "block.minecraft.jack_o_lantern": "Đèn bí ngô",
  "block.minecraft.jigsaw": "Khối mảnh ghép",
  "block.minecraft.jukebox": "Hộp chơi nhạc",
  "block.minecraft.jungle_button": "Nút gỗ rừng",
  "block.minecraft.jungle_door": "Cửa gỗ rừng",
  "block.minecraft.jungle_fence": "Hàng rào gỗ rừng",
  "block.minecraft.jungle_fence_gate": "Cổng rào gỗ rừng",
  "block.minecraft.jungle_hanging_sign": "Tấm biển treo gỗ rừng",
  "block.minecraft.jungle_leaves": "Lá rừng",
  "block.minecraft.jungle_log": "Thân cây rừng",
  "block.minecraft.jungle_planks": "Ván gỗ rừng",
  "block.minecraft.jungle_pressure_plate": "Tấm áp lực gỗ rừng",
  "block.minecraft.jungle_sapling": "Chồi cây rừng",
  "block.minecraft.jungle_shelf": "Kệ gỗ rừng",
  "block.minecraft.jungle_sign": "Tấm biển gỗ rừng",
  "block.minecraft.jungle_slab": "Phiến gỗ rừng",
  "block.minecraft.jungle_stairs": "Cầu thang gỗ rừng",
  "block.minecraft.jungle_trapdoor": "Cửa sập gỗ rừng",
  "block.minecraft.jungle_wall_hanging_sign": "Tấm biển treo gỗ rừng trên tường",
  "block.minecraft.jungle_wall_sign": "Tấm biển gỗ rừng trên tường",
  "block.minecraft.jungle_wood": "Gỗ rừng",
  "block.minecraft.kelp": "Tảo bẹ",
  "block.minecraft.kelp_plant": "Cây tảo bẹ",
  "block.minecraft.ladder": "Thang",
  "block.minecraft.lantern": "Đèn lồng",
  "block.minecraft.lapis_block": "Khối ngọc lưu ly",
  "block.minecraft.lapis_ore": "Quặng ngọc lưu ly",
  "block.minecraft.large_amethyst_bud": "Nụ thạch anh tím lớn",
  "block.minecraft.large_fern": "Dương xỉ lớn",
  "block.minecraft.lava": "Dung nham",
  "block.minecraft.lava_cauldron": "Vạc dung nham",
  "block.minecraft.leaf_litter": "Lá khô",
  "block.minecraft.lectern": "Bục để sách",
  "block.minecraft.lever": "Cần gạt",
  "block.minecraft.light": "Ánh sáng",
  "block.minecraft.light_blue_banner": "Cờ hiệu xanh nước biển nhạt",
  "block.minecraft.light_blue_bed": "Giường xanh nước biển nhạt",
  "block.minecraft.light_blue_candle": "Nến xanh nước biển nhạt",
  "block.minecraft.light_blue_candle_cake": "Bánh ngọt có nến xanh nước biển nhạt",
  "block.minecraft.light_blue_carpet": "Thảm xanh nước biển nhạt",
  "block.minecraft.light_blue_concrete": "Bê tông xanh nước biển nhạt",
  "block.minecraft.light_blue_concrete_powder": "Bột bê tông xanh nước biển nhạt",
  "block.minecraft.light_blue_glazed_terracotta": "Đất nung tráng men xanh nước biển nhạt",
  "block.minecraft.light_blue_shulker_box": "Hộp Shulker xanh nước biển nhạt",
  "block.minecraft.light_blue_stained_glass": "Thủy tinh được nhuộm xanh nước biển nhạt",
  "block.minecraft.light_blue_stained_glass_pane": "Tấm thủy tinh được nhuộm xanh nước biển nhạt",
  "block.minecraft.light_blue_terracotta": "Đất nung xanh nước biển nhạt",
  "block.minecraft.light_blue_wool": "Len xanh nhạt",
  "block.minecraft.light_gray_banner": "Cờ hiệu xám nhạt",
  "block.minecraft.light_gray_bed": "Giường xám nhạt",
  "block.minecraft.light_gray_candle": "Nến xám nhạt",
  "block.minecraft.light_gray_candle_cake": "Bánh ngọt có nến xám nhạt",
  "block.minecraft.light_gray_carpet": "Thảm xám nhạt",
  "block.minecraft.light_gray_concrete": "Bê tông xám nhạt",
  "block.minecraft.light_gray_concrete_powder": "Bột bê tông xám nhạt",
  "block.minecraft.light_gray_glazed_terracotta": "Đất nung tráng men xám nhạt",
  "block.minecraft.light_gray_shulker_box": "Hộp Shulker xám nhạt",
  "block.minecraft.light_gray_stained_glass": "Thủy tinh được nhuộm xám nhạt",
  "block.minecraft.light_gray_stained_glass_pane": "Tấm thủy tinh được nhuộm xám nhạt",
  "block.minecraft.light_gray_terracotta": "Đất nung xám nhạt",
  "block.minecraft.light_gray_wool": "Len xám nhạt",
  "block.minecraft.light_weighted_pressure_plate": "Tấm áp lực nhẹ",
  "block.minecraft.lightning_rod": "Cột thu lôi",
  "block.minecraft.lilac": "Tử đinh hương",
  "block.minecraft.lily_of_the_valley": "Linh lan",
  "block.minecraft.lily_pad": "Lá súng",
  "block.minecraft.lime_banner": "Cờ hiệu xanh lá mạ",
  "block.minecraft.lime_bed": "Giường xanh lá mạ",
  "block.minecraft.lime_candle": "Nến xanh lá mạ",
  "block.minecraft.lime_candle_cake": "Bánh ngọt có nến xanh lá mạ",
  "block.minecraft.lime_carpet": "Thảm xanh lá mạ",
  "block.minecraft.lime_concrete": "Bê tông xanh lá mạ",
  "block.minecraft.lime_concrete_powder": "Bột bê tông xanh lá mạ",
  "block.minecraft.lime_glazed_terracotta": "Đất nung tráng men xanh lá mạ",
  "block.minecraft.lime_shulker_box": "Hộp Shulker xanh lá mạ",
  "block.minecraft.lime_stained_glass": "Thủy tinh được nhuộm xanh lá mạ",
  "block.minecraft.lime_stained_glass_pane": "Tấm thủy tinh được nhuộm xanh lá mạ",
  "block.minecraft.lime_terracotta": "Đất nung xanh lá mạ",
  "block.minecraft.lime_wool": "Len xanh lá mạ",
  "block.minecraft.lodestone": "Đá nam châm",
  "block.minecraft.loom": "Khung cửi",
  "block.minecraft.magenta_banner": "Cờ hiệu đỏ sậm",
  "block.minecraft.magenta_bed": "Giường đỏ sậm",
  "block.minecraft.magenta_candle": "Nến đỏ sậm",
  "block.minecraft.magenta_candle_cake": "Bánh ngọt có nến đỏ sậm",
  "block.minecraft.magenta_carpet": "Thảm đỏ sậm",
  "block.minecraft.magenta_concrete": "Bê tông đỏ sậm",
  "block.minecraft.magenta_concrete_powder": "Bột bê tông đỏ sậm",
  "block.minecraft.magenta_glazed_terracotta": "Đất nung tráng men đỏ sậm",
  "block.minecraft.magenta_shulker_box": "Hộp Shulker đỏ sậm",
  "block.minecraft.magenta_stained_glass": "Thủy tinh được nhuộm đỏ sậm",
  "block.minecraft.magenta_stained_glass_pane": "Tấm thủy tinh được nhuộm đỏ sậm",
  "block.minecraft.magenta_terracotta": "Đất nung đỏ sậm",
  "block.minecraft.magenta_wool": "Len đỏ sậm",
  "block.minecraft.magma_block": "Khối dung nham",
  "block.minecraft.mangrove_button": "Nút gỗ đước",
  "block.minecraft.mangrove_door": "Cửa gỗ đước",
  "block.minecraft.mangrove_fence": "Hàng rào gỗ đước",
  "block.minecraft.mangrove_fence_gate": "Cổng rào gỗ đước",
  "block.minecraft.mangrove_hanging_sign": "Tấm biển treo gỗ đước",
  "block.minecraft.mangrove_leaves": "Lá đước",
  "block.minecraft.mangrove_log": "Thân cây đước",
  "block.minecraft.mangrove_planks": "Ván gỗ đước",
  "block.minecraft.mangrove_pressure_plate": "Tấm áp lực gỗ đước",
  "block.minecraft.mangrove_propagule": "Chồi cây đước",
  "block.minecraft.mangrove_roots": "Rễ cây đước",
  "block.minecraft.mangrove_shelf": "Kệ gỗ đước",
  "block.minecraft.mangrove_sign": "Tấm biển gỗ đước",
  "block.minecraft.mangrove_slab": "Phiến gỗ đước",
  "block.minecraft.mangrove_stairs": "Cầu thang gỗ đước",
  "block.minecraft.mangrove_trapdoor": "Cửa sập gỗ đước",
  "block.minecraft.mangrove_wall_hanging_sign": "Tấm biển treo gỗ đước trên tường",
  "block.minecraft.mangrove_wall_sign": "Tấm biển gỗ đước treo tường",
  "block.minecraft.mangrove_wood": "Gỗ đước",
  "block.minecraft.medium_amethyst_bud": "Nụ thạch anh tím trung bình",
  "block.minecraft.melon": "Dưa hấu",
  "block.minecraft.melon_stem": "Cuống dưa hấu",
  "block.minecraft.moss_block": "Khối rêu",
  "block.minecraft.moss_carpet": "Thảm rêu",
  "block.minecraft.mossy_cobblestone": "Đá cuội phủ rêu",
  "block.minecraft.mossy_cobblestone_slab": "Phiến đá cuội phủ rêu",
  "block.minecraft.mossy_cobblestone_stairs": "Cầu thang đá cuội phủ rêu",
  "block.minecraft.mossy_cobblestone_wall": "Tường đá cuội phủ rêu",
  "block.minecraft.mossy_stone_brick_slab": "Phiến gạch đá phủ rêu",
  "block.minecraft.mossy_stone_brick_stairs": "Cầu thang gạch đá phủ rêu",
  "block.minecraft.mossy_stone_brick_wall": "Tường gạch đá phủ rêu",
  "block.minecraft.mossy_stone_bricks": "Gạch đá phủ rêu",
  "block.minecraft.moving_piston": "Piston di chuyển",
  "block.minecraft.mud": "Bùn",
  "block.minecraft.mud_brick_slab": "Phiến gạch bùn",
  "block.minecraft.mud_brick_stairs": "Cầu thang gạch bùn",
  "block.minecraft.mud_brick_wall": "Tường gạch bùn",
  "block.minecraft.mud_bricks": "Gạch bùn",
  "block.minecraft.muddy_mangrove_roots": "Rễ cây đước ngấm bùn",
  "block.minecraft.mushroom_stem": "Thân nấm",
  "block.minecraft.mycelium": "Khuẩn ty thể",
  "block.minecraft.nether_brick_fence": "Hàng rào gạch Nether",
  "block.minecraft.nether_brick_slab": "Phiến gạch Nether",
  "block.minecraft.nether_brick_stairs": "Cầu thang gạch Nether",
  "block.minecraft.nether_brick_wall": "Tường gạch Nether",
  "block.minecraft.nether_bricks": "Gạch Nether",
  "block.minecraft.nether_gold_ore": "Quặng vàng Nether",
  "block.minecraft.nether_portal": "Cổng Nether",
  "block.minecraft.nether_quartz_ore": "Quặng thạch anh Nether",
  "block.minecraft.nether_sprouts": "Mộng cây Nether",
  "block.minecraft.nether_wart": "Bướu Nether",
  "block.minecraft.nether_wart_block": "Khối bướu Nether",
  "block.minecraft.netherite_block": "Khối Netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Khối nốt nhạc",
  "block.minecraft.oak_button": "Nút gỗ sồi",
  "block.minecraft.oak_door": "Cửa gỗ sồi",
  "block.minecraft.oak_fence": "Hàng rào gỗ sồi",
  "block.minecraft.oak_fence_gate": "Cổng rào gỗ sồi",
  "block.minecraft.oak_hanging_sign": "Tấm biển treo gỗ sồi",
  "block.minecraft.oak_leaves": "Lá sồi",
  "block.minecraft.oak_log": "Thân cây sồi",
  "block.minecraft.oak_planks": "Ván gỗ sồi",
  "block.minecraft.oak_pressure_plate": "Tấm áp lực gỗ sồi",
  "block.minecraft.oak_sapling": "Chồi cây sồi",
  "block.minecraft.oak_shelf": "Kệ gỗ sồi",
  "block.minecraft.oak_sign": "Tấm biển gỗ sồi",
  "block.minecraft.oak_slab": "Phiến gỗ sồi",
  "block.minecraft.oak_stairs": "Cầu thang gỗ sồi",
  "block.minecraft.oak_trapdoor": "Cửa sập gỗ sồi",
  "block.minecraft.oak_wall_hanging_sign": "Tấm biển treo gỗ sồi trên tường",
  "block.minecraft.oak_wall_sign": "Tấm biển gỗ sồi trên tường",
  "block.minecraft.oak_wood": "Gỗ sồi",
  "block.minecraft.observer": "Khối theo dõi",
  "block.minecraft.obsidian": "Hắc diện thạch",
  "block.minecraft.ochre_froglight": "Đèn ếch nâu hoàng thổ",
  "block.minecraft.ominous_banner": "Cờ báo hiệu điềm xấu",
  "block.minecraft.open_eyeblossom": "Hoa mắt mở",
  "block.minecraft.orange_banner": "Cờ hiệu cam",
  "block.minecraft.orange_bed": "Giường cam",
  "block.minecraft.orange_candle": "Nến cam",
  "block.minecraft.orange_candle_cake": "Bánh ngọt có nến cam",
  "block.minecraft.orange_carpet": "Thảm cam",
  "block.minecraft.orange_concrete": "Bê tông cam",
  "block.minecraft.orange_concrete_powder": "Bột bê tông cam",
  "block.minecraft.orange_glazed_terracotta": "Đất nung tráng men cam",
  "block.minecraft.orange_shulker_box": "Hộp Shulker cam",
  "block.minecraft.orange_stained_glass": "Thủy tinh được nhuộm cam",
  "block.minecraft.orange_stained_glass_pane": "Tấm thủy tinh được nhuộm cam",
  "block.minecraft.orange_terracotta": "Đất nung cam",
  "block.minecraft.orange_tulip": "Uất kim hương cam",
  "block.minecraft.orange_wool": "Len cam",
  "block.minecraft.oxeye_daisy": "Cúc trắng",
  "block.minecraft.oxidized_chiseled_copper": "Khối đồng được đục bị oxi hoá",
  "block.minecraft.oxidized_copper": "Khối đồng bị oxi hóa",
  "block.minecraft.oxidized_copper_bars": "Hàng rào đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_bulb": "Bóng đèn đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_chain": "Dây xích đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_chest": "Rương đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_door": "Cửa đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_golem_statue": "Tượng người đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_grate": "Lưới đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_lantern": "Đèn lồng đồng bị oxi hoá",
  "block.minecraft.oxidized_copper_trapdoor": "Cửa sập đồng bị oxi hoá",
  "block.minecraft.oxidized_cut_copper": "Khối đồng được cắt bị oxi hóa",
  "block.minecraft.oxidized_cut_copper_slab": "Phiến đồng được cắt bị oxi hoá",
  "block.minecraft.oxidized_cut_copper_stairs": "Cầu thang đồng được cắt bị oxi hóa",
  "block.minecraft.oxidized_lightning_rod": "Cột thu lôi bị oxi hoá",
  "block.minecraft.packed_ice": "Băng nén",
  "block.minecraft.packed_mud": "Bùn nén",
  "block.minecraft.pale_hanging_moss": "Rêu treo nhạt",
  "block.minecraft.pale_moss_block": "Khối rêu nhạt",
  "block.minecraft.pale_moss_carpet": "Thảm rêu nhạt",
  "block.minecraft.pale_oak_button": "Nút gỗ sồi nhợt",
  "block.minecraft.pale_oak_door": "Cửa gỗ sồi nhợt",
  "block.minecraft.pale_oak_fence": "Hàng rào gỗ sồi nhợt",
  "block.minecraft.pale_oak_fence_gate": "Cổng rào gỗ sồi nhợt",
  "block.minecraft.pale_oak_hanging_sign": "Tấm biển treo gỗ sồi nhợt",
  "block.minecraft.pale_oak_leaves": "Lá sồi nhợt",
  "block.minecraft.pale_oak_log": "Thân cây sồi nhợt",
  "block.minecraft.pale_oak_planks": "Ván gỗ sồi nhợt",
  "block.minecraft.pale_oak_pressure_plate": "Tấm áp lực gỗ sồi nhợt",
  "block.minecraft.pale_oak_sapling": "Chồi cây sồi nhợt",
  "block.minecraft.pale_oak_shelf": "Kệ gỗ sồi nhợt",
  "block.minecraft.pale_oak_sign": "Tấm biển gỗ sồi nhợt",
  "block.minecraft.pale_oak_slab": "Phiến gỗ sồi nhợt",
  "block.minecraft.pale_oak_stairs": "Cầu thang gỗ sồi nhợt",
  "block.minecraft.pale_oak_trapdoor": "Cửa sập gỗ sồi nhợt",
  "block.minecraft.pale_oak_wall_hanging_sign": "Tấm biển treo gỗ sồi nhợt trên tường",
  "block.minecraft.pale_oak_wall_sign": "Tấm biển gỗ sồi nhợt trên tường",
  "block.minecraft.pale_oak_wood": "Gỗ sồi nhợt",
  "block.minecraft.pearlescent_froglight": "Đèn ếch tím ngọc trai",
  "block.minecraft.peony": "Mẫu đơn",
  "block.minecraft.petrified_oak_slab": "Phiến gỗ sồi bị hoá đá",
  "block.minecraft.piglin_head": "Đầu piglin",
  "block.minecraft.piglin_wall_head": "Đầu piglin trên tường",
  "block.minecraft.pink_banner": "Cờ hiệu hồng",
  "block.minecraft.pink_bed": "Giường hồng",
  "block.minecraft.pink_candle": "Nến hồng",
  "block.minecraft.pink_candle_cake": "Bánh ngọt có nến hồng",
  "block.minecraft.pink_carpet": "Thảm hồng",
  "block.minecraft.pink_concrete": "Bê tông hồng",
  "block.minecraft.pink_concrete_powder": "Bột bê tông hồng",
  "block.minecraft.pink_glazed_terracotta": "Đất nung tráng men hồng",
  "block.minecraft.pink_petals": "Cánh hoa màu hồng",
  "block.minecraft.pink_shulker_box": "Hộp Shulker hồng",
  "block.minecraft.pink_stained_glass": "Thủy tinh được nhuộm hồng",
  "block.minecraft.pink_stained_glass_pane": "Tấm thủy tinh được nhuộm hồng",
  "block.minecraft.pink_terracotta": "Đất nung hồng",
  "block.minecraft.pink_tulip": "Uất kim hương hồng",
  "block.minecraft.pink_wool": "Len hồng",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Đầu Piston",
  "block.minecraft.pitcher_crop": "Cây trồng nắp ấm",
  "block.minecraft.pitcher_plant": "Cây nắp ấm",
  "block.minecraft.player_head": "Đầu người chơi",
  "block.minecraft.player_head.named": "Đầu của %s",
  "block.minecraft.player_wall_head": "Đầu người chơi trên tường",
  "block.minecraft.podzol": "Đất podzol",
  "block.minecraft.pointed_dripstone": "Thạch nhũ nhọn",
  "block.minecraft.polished_andesite": "Đá andesit được đánh bóng",
  "block.minecraft.polished_andesite_slab": "Phiến đá andesit được đánh bóng",
  "block.minecraft.polished_andesite_stairs": "Cầu thang đá andesit được đánh bóng",
  "block.minecraft.polished_basalt": "Đá bazan được đánh bóng",
  "block.minecraft.polished_blackstone": "Đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_slab": "Phiến gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_stairs": "Cầu thang gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_brick_wall": "Tường gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_bricks": "Gạch đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_button": "Nút đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_pressure_plate": "Tấm áp lực đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_slab": "Phiến đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_stairs": "Cầu thang đá đen được đánh bóng",
  "block.minecraft.polished_blackstone_wall": "Tường đá đen được đánh bóng",
  "block.minecraft.polished_deepslate": "Đá bảng sâu được đánh bóng",
  "block.minecraft.polished_deepslate_slab": "Phiến đá bảng sâu được đánh bóng",
  "block.minecraft.polished_deepslate_stairs": "Cầu thang đá bảng sâu được đánh bóng",
  "block.minecraft.polished_deepslate_wall": "Tường đá bảng sâu được đánh bóng",
  "block.minecraft.polished_diorite": "Đá diorit được đánh bóng",
  "block.minecraft.polished_diorite_slab": "Phiến đá diorit được đánh bóng",
  "block.minecraft.polished_diorite_stairs": "Cầu thang đá diorit được đánh bóng",
  "block.minecraft.polished_granite": "Đá hoa cương được đánh bóng",
  "block.minecraft.polished_granite_slab": "Phiến đá hoa cương được đánh bóng",
  "block.minecraft.polished_granite_stairs": "Cầu thang đá hoa cương được đánh bóng",
  "block.minecraft.polished_tuff": "Đá túp được đánh bóng",
  "block.minecraft.polished_tuff_slab": "Phiến đá túp được đánh bóng",
  "block.minecraft.polished_tuff_stairs": "Cầu thang đá túp được đánh bóng",
  "block.minecraft.polished_tuff_wall": "Tường đá túp được đánh bóng",
  "block.minecraft.poppy": "Anh túc",
  "block.minecraft.potatoes": "Khoai tây",
  "block.minecraft.potted_acacia_sapling": "Chậu chồi cây xiêm gai",
  "block.minecraft.potted_allium": "Chậu hành tím",
  "block.minecraft.potted_azalea_bush": "Chậu đỗ quyên",
  "block.minecraft.potted_azure_bluet": "Chậu thiến thảo xanh",
  "block.minecraft.potted_bamboo": "Chậu cây tre",
  "block.minecraft.potted_birch_sapling": "Chậu chồi cây bạch dương",
  "block.minecraft.potted_blue_orchid": "Chậu phong lan xanh",
  "block.minecraft.potted_brown_mushroom": "Chậu nấm nâu",
  "block.minecraft.potted_cactus": "Chậu xương rồng",
  "block.minecraft.potted_cherry_sapling": "Chậu chồi cây anh đào",
  "block.minecraft.potted_closed_eyeblossom": "Chậu hoa mắt nhắm",
  "block.minecraft.potted_cornflower": "Chậu thanh cúc",
  "block.minecraft.potted_crimson_fungus": "Chậu nấm đỏ thẫm",
  "block.minecraft.potted_crimson_roots": "Chậu rễ đỏ thẫm",
  "block.minecraft.potted_dandelion": "Chậu bồ công anh",
  "block.minecraft.potted_dark_oak_sapling": "Chậu chồi cây sồi sẫm",
  "block.minecraft.potted_dead_bush": "Chậu cây khô",
  "block.minecraft.potted_fern": "Chậu dương xỉ",
  "block.minecraft.potted_flowering_azalea_bush": "Chậu đỗ quyên có hoa",
  "block.minecraft.potted_golden_dandelion": "Chậu bồ công anh vàng",
  "block.minecraft.potted_jungle_sapling": "Chậu chồi cây rừng",
  "block.minecraft.potted_lily_of_the_valley": "Chậu linh lan",
  "block.minecraft.potted_mangrove_propagule": "Chậu chồi cây đước",
  "block.minecraft.potted_oak_sapling": "Chậu chồi cây sồi",
  "block.minecraft.potted_open_eyeblossom": "Chậu hoa mắt mở",
  "block.minecraft.potted_orange_tulip": "Chậu uất kim hương cam",
  "block.minecraft.potted_oxeye_daisy": "Chậu cúc trắng",
  "block.minecraft.potted_pale_oak_sapling": "Chậu chồi cây sồi nhợt",
  "block.minecraft.potted_pink_tulip": "Chậu uất kim hương hồng",
  "block.minecraft.potted_poppy": "Chậu anh túc",
  "block.minecraft.potted_red_mushroom": "Chậu nấm đỏ",
  "block.minecraft.potted_red_tulip": "Chậu uất kim hương đỏ",
  "block.minecraft.potted_spruce_sapling": "Chậu chồi cây vân sam",
  "block.minecraft.potted_torchflower": "Chậu hoa đuốc",
  "block.minecraft.potted_warped_fungus": "Chậu nấm kì dị",
  "block.minecraft.potted_warped_roots": "Chậu rễ kì dị",
  "block.minecraft.potted_white_tulip": "Chậu uất kim hương trắng",
  "block.minecraft.potted_wither_rose": "Chậu hoa hồng Wither",
  "block.minecraft.powder_snow": "Bột tuyết",
  "block.minecraft.powder_snow_cauldron": "Vạc bột tuyết",
  "block.minecraft.powered_rail": "Đường ray tăng tốc",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Phiến gạch Prismarin",
  "block.minecraft.prismarine_brick_stairs": "Cầu thang gạch Prismarin",
  "block.minecraft.prismarine_bricks": "Gạch Prismarin",
  "block.minecraft.prismarine_slab": "Phiến Prismarin",
  "block.minecraft.prismarine_stairs": "Cầu thang Prismarin",
  "block.minecraft.prismarine_wall": "Tường Prismarin",
  "block.minecraft.pumpkin": "Bí ngô",
  "block.minecraft.pumpkin_stem": "Cuống bí ngô",
  "block.minecraft.purple_banner": "Cờ hiệu tím",
  "block.minecraft.purple_bed": "Giường tím",
  "block.minecraft.purple_candle": "Nến tím",
  "block.minecraft.purple_candle_cake": "Bánh ngọt có nến tím",
  "block.minecraft.purple_carpet": "Thảm tím",
  "block.minecraft.purple_concrete": "Bê tông tím",
  "block.minecraft.purple_concrete_powder": "Bột bê tông tím",
  "block.minecraft.purple_glazed_terracotta": "Đất nung tráng men tím",
  "block.minecraft.purple_shulker_box": "Hộp Shulker tím",
  "block.minecraft.purple_stained_glass": "Thủy tinh được nhuộm tím",
  "block.minecraft.purple_stained_glass_pane": "Tấm thủy tinh được nhuộm tím",
  "block.minecraft.purple_terracotta": "Đất nung tím",
  "block.minecraft.purple_wool": "Len tím",
  "block.minecraft.purpur_block": "Khối purpur",
  "block.minecraft.purpur_pillar": "Cột trụ purpur",
  "block.minecraft.purpur_slab": "Phiến purpur",
  "block.minecraft.purpur_stairs": "Cầu thang purpur",
  "block.minecraft.quartz_block": "Khối thạch anh",
  "block.minecraft.quartz_bricks": "Gạch thạch anh",
  "block.minecraft.quartz_pillar": "Cột trụ thạch anh",
  "block.minecraft.quartz_slab": "Phiến thạch anh",
  "block.minecraft.quartz_stairs": "Cầu thang thạch anh",
  "block.minecraft.rail": "Đường ray",
  "block.minecraft.raw_copper_block": "Khối đồng thô",
  "block.minecraft.raw_gold_block": "Khối vàng thô",
  "block.minecraft.raw_iron_block": "Khối sắt thô",
  "block.minecraft.red_banner": "Cờ hiệu đỏ",
  "block.minecraft.red_bed": "Giường đỏ",
  "block.minecraft.red_candle": "Nến đỏ",
  "block.minecraft.red_candle_cake": "Bánh ngọt có nến đỏ",
  "block.minecraft.red_carpet": "Thảm đỏ",
  "block.minecraft.red_concrete": "Bê tông đỏ",
  "block.minecraft.red_concrete_powder": "Bột bê tông đỏ",
  "block.minecraft.red_glazed_terracotta": "Đất nung tráng men đỏ",
  "block.minecraft.red_mushroom": "Nấm đỏ",
  "block.minecraft.red_mushroom_block": "Khối nấm đỏ",
  "block.minecraft.red_nether_brick_slab": "Phiến gạch Nether đỏ",
  "block.minecraft.red_nether_brick_stairs": "Cầu thang gạch Nether đỏ",
  "block.minecraft.red_nether_brick_wall": "Tường gạch Nether đỏ",
  "block.minecraft.red_nether_bricks": "Gạch Nether đỏ",
  "block.minecraft.red_sand": "Cát đỏ",
  "block.minecraft.red_sandstone": "Cát kết đỏ",
  "block.minecraft.red_sandstone_slab": "Phiến cát kết đỏ",
  "block.minecraft.red_sandstone_stairs": "Cầu thang cát kết đỏ",
  "block.minecraft.red_sandstone_wall": "Tường cát kết đỏ",
  "block.minecraft.red_shulker_box": "Hộp Shulker đỏ",
  "block.minecraft.red_stained_glass": "Thủy tinh được nhuộm đỏ",
  "block.minecraft.red_stained_glass_pane": "Tấm thủy tinh được nhuộm đỏ",
  "block.minecraft.red_terracotta": "Đất nung đỏ",
  "block.minecraft.red_tulip": "Uất kim hương đỏ",
  "block.minecraft.red_wool": "Len đỏ",
  "block.minecraft.redstone_block": "Khối Redstone",
  "block.minecraft.redstone_lamp": "Đèn Redstone",
  "block.minecraft.redstone_ore": "Quặng Redstone",
  "block.minecraft.redstone_torch": "Đuốc Redstone",
  "block.minecraft.redstone_wall_torch": "Đuốc Redstone trên tường",
  "block.minecraft.redstone_wire": "Dây dẫn Redstone",
  "block.minecraft.reinforced_deepslate": "Đá bảng sâu được gia cố",
  "block.minecraft.repeater": "Bộ lặp Redstone",
  "block.minecraft.repeating_command_block": "Khối lệnh lặp lại",
  "block.minecraft.resin_block": "Khối nhựa cây",
  "block.minecraft.resin_brick_slab": "Phiến gạch nhựa cây",
  "block.minecraft.resin_brick_stairs": "Cầu thang gạch nhựa cây",
  "block.minecraft.resin_brick_wall": "Tường gạch nhựa cây",
  "block.minecraft.resin_bricks": "Gạch nhựa cây",
  "block.minecraft.resin_clump": "Cục nhựa cây",
  "block.minecraft.respawn_anchor": "Neo hồi sinh",
  "block.minecraft.rooted_dirt": "Đất đã bén rễ",
  "block.minecraft.rose_bush": "Bụi hoa hồng",
  "block.minecraft.sand": "Cát",
  "block.minecraft.sandstone": "Cát kết",
  "block.minecraft.sandstone_slab": "Phiến cát kết",
  "block.minecraft.sandstone_stairs": "Cầu thang cát kết",
  "block.minecraft.sandstone_wall": "Tường cát kết",
  "block.minecraft.scaffolding": "Giàn giáo",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Khối xúc tác Sculk",
  "block.minecraft.sculk_sensor": "Cảm biến Sculk",
  "block.minecraft.sculk_shrieker": "Khối Sculk la hét",
  "block.minecraft.sculk_vein": "Mạch Sculk",
  "block.minecraft.sea_lantern": "Đèn biển",
  "block.minecraft.sea_pickle": "Dưa muối biển",
  "block.minecraft.seagrass": "Cỏ biển",
  "block.minecraft.set_spawn": "Điểm hồi sinh đã được chỉnh",
  "block.minecraft.short_dry_grass": "Cỏ khô thấp",
  "block.minecraft.short_grass": "Cỏ thấp",
  "block.minecraft.shroomlight": "Đèn nấm",
  "block.minecraft.shulker_box": "Hộp Shulker",
  "block.minecraft.skeleton_skull": "Đầu lâu bộ xương",
  "block.minecraft.skeleton_wall_skull": "Đầu lâu bộ xương trên tường",
  "block.minecraft.slime_block": "Khối chất nhờn",
  "block.minecraft.small_amethyst_bud": "Nụ thạch anh tím nhỏ",
  "block.minecraft.small_dripleaf": "Lá nhỏ giọt nhỏ",
  "block.minecraft.smithing_table": "Bàn rèn",
  "block.minecraft.smoker": "Lò hun khói",
  "block.minecraft.smooth_basalt": "Đá bazan mịn",
  "block.minecraft.smooth_quartz": "Khối thạch anh mịn",
  "block.minecraft.smooth_quartz_slab": "Phiến thạch anh mịn",
  "block.minecraft.smooth_quartz_stairs": "Cầu thang thạch anh mịn",
  "block.minecraft.smooth_red_sandstone": "Cát kết đỏ mịn",
  "block.minecraft.smooth_red_sandstone_slab": "Phiến cát kết đỏ mịn",
  "block.minecraft.smooth_red_sandstone_stairs": "Cầu thang cát kết đỏ mịn",
  "block.minecraft.smooth_sandstone": "Cát kết mịn",
  "block.minecraft.smooth_sandstone_slab": "Phiến cát kết mịn",
  "block.minecraft.smooth_sandstone_stairs": "Cầu thang cát kết mịn",
  "block.minecraft.smooth_stone": "Đá mịn",
  "block.minecraft.smooth_stone_slab": "Phiến đá mịn",
  "block.minecraft.sniffer_egg": "Trứng kẻ đánh hơi",
  "block.minecraft.snow": "Tuyết",
  "block.minecraft.snow_block": "Khối tuyết",
  "block.minecraft.soul_campfire": "Lửa trại linh hồn",
  "block.minecraft.soul_fire": "Lửa linh hồn",
  "block.minecraft.soul_lantern": "Đèn lồng linh hồn",
  "block.minecraft.soul_sand": "Cát linh hồn",
  "block.minecraft.soul_soil": "Đất linh hồn",
  "block.minecraft.soul_torch": "Đuốc linh hồn",
  "block.minecraft.soul_wall_torch": "Đuốc linh hồn trên tường",
  "block.minecraft.spawn.not_valid": "Bạn không có giường ở nhà hoặc neo hồi sinh được nạp đầy, hoặc nó đã bị chiếm",
  "block.minecraft.spawner": "Lồng triệu hồi quái vật",
  "block.minecraft.spawner.desc1": "Tương tác với trứng sinh ra:",
  "block.minecraft.spawner.desc2": "Đặt loại sinh vật",
  "block.minecraft.sponge": "Miếng bọt biển",
  "block.minecraft.spore_blossom": "Hoa bào tử",
  "block.minecraft.spruce_button": "Nút gỗ vân sam",
  "block.minecraft.spruce_door": "Cửa gỗ vân sam",
  "block.minecraft.spruce_fence": "Hàng rào gỗ vân sam",
  "block.minecraft.spruce_fence_gate": "Cổng rào gỗ vân sam",
  "block.minecraft.spruce_hanging_sign": "Tấm biển treo gỗ vân sam",
  "block.minecraft.spruce_leaves": "Lá vân sam",
  "block.minecraft.spruce_log": "Thân cây vân sam",
  "block.minecraft.spruce_planks": "Ván gỗ vân sam",
  "block.minecraft.spruce_pressure_plate": "Tấm áp lực gỗ vân sam",
  "block.minecraft.spruce_sapling": "Chồi cây vân sam",
  "block.minecraft.spruce_shelf": "Kệ gỗ vân sam",
  "block.minecraft.spruce_sign": "Tấm biển gỗ vân sam",
  "block.minecraft.spruce_slab": "Phiến gỗ vân sam",
  "block.minecraft.spruce_stairs": "Cầu thang gỗ vân sam",
  "block.minecraft.spruce_trapdoor": "Cửa sập gỗ vân sam",
  "block.minecraft.spruce_wall_hanging_sign": "Tấm biển treo gỗ vân sam trên tường",
  "block.minecraft.spruce_wall_sign": "Tấm biển gỗ vân sam trên tường",
  "block.minecraft.spruce_wood": "Gỗ vân sam",
  "block.minecraft.sticky_piston": "Piston dính",
  "block.minecraft.stone": "Đá",
  "block.minecraft.stone_brick_slab": "Phiến gạch đá",
  "block.minecraft.stone_brick_stairs": "Cầu thang gạch đá",
  "block.minecraft.stone_brick_wall": "Tường gạch đá",
  "block.minecraft.stone_bricks": "Gạch đá",
  "block.minecraft.stone_button": "Nút đá",
  "block.minecraft.stone_pressure_plate": "Tấm áp lực đá",
  "block.minecraft.stone_slab": "Phiến đá",
  "block.minecraft.stone_stairs": "Cầu thang đá",
  "block.minecraft.stonecutter": "Máy cắt đá",
  "block.minecraft.stripped_acacia_log": "Thân cây xiêm gai đã cạo vỏ",
  "block.minecraft.stripped_acacia_wood": "Gỗ xiêm gai đã cạo vỏ",
  "block.minecraft.stripped_bamboo_block": "Khối tre đã cạo vỏ",
  "block.minecraft.stripped_birch_log": "Thân cây bạch dương đã cạo vỏ",
  "block.minecraft.stripped_birch_wood": "Gỗ bạch dương đã cạo vỏ",
  "block.minecraft.stripped_cherry_log": "Thân cây anh đào đã cạo vỏ",
  "block.minecraft.stripped_cherry_wood": "Gỗ anh đào đã cạo vỏ",
  "block.minecraft.stripped_crimson_hyphae": "Sợi nấm đỏ thẫm đã cạo vỏ",
  "block.minecraft.stripped_crimson_stem": "Cuống đỏ thẫm đã cạo vỏ",
  "block.minecraft.stripped_dark_oak_log": "Thân cây sồi sẫm đã cạo vỏ",
  "block.minecraft.stripped_dark_oak_wood": "Gỗ sồi sẫm đã cạo vỏ",
  "block.minecraft.stripped_jungle_log": "Thân cây rừng đã cạo vỏ",
  "block.minecraft.stripped_jungle_wood": "Gỗ rừng đã cạo vỏ",
  "block.minecraft.stripped_mangrove_log": "Thân cây đước đã cạo vỏ",
  "block.minecraft.stripped_mangrove_wood": "Gỗ đước đã cạo vỏ",
  "block.minecraft.stripped_oak_log": "Thân cây sồi đã cạo vỏ",
  "block.minecraft.stripped_oak_wood": "Gỗ sồi đã cạo vỏ",
  "block.minecraft.stripped_pale_oak_log": "Thân cây sồi nhợt đã cạo vỏ",
  "block.minecraft.stripped_pale_oak_wood": "Gỗ sồi nhợt đã cạo vỏ",
  "block.minecraft.stripped_spruce_log": "Thân cây vân sam đã cạo vỏ",
  "block.minecraft.stripped_spruce_wood": "Gỗ vân sam đã cạo vỏ",
  "block.minecraft.stripped_warped_hyphae": "Sợi nấm kì dị đã cạo vỏ",
  "block.minecraft.stripped_warped_stem": "Cuống kì dị đã cạo vỏ",
  "block.minecraft.structure_block": "Khối cấu trúc",
  "block.minecraft.structure_void": "Cấu trúc trống",
  "block.minecraft.sugar_cane": "Cây mía",
  "block.minecraft.sunflower": "Hướng dương",
  "block.minecraft.suspicious_gravel": "Sỏi đáng ngờ",
  "block.minecraft.suspicious_sand": "Cát đáng ngờ",
  "block.minecraft.sweet_berry_bush": "Bụi cây mọng ngọt",
  "block.minecraft.tall_dry_grass": "Cỏ khô cao",
  "block.minecraft.tall_grass": "Cỏ cao",
  "block.minecraft.tall_seagrass": "Cỏ biển cao",
  "block.minecraft.target": "Bia bắn",
  "block.minecraft.terracotta": "Đất nung",
  "block.minecraft.test_block": "Khối kiểm tra",
  "block.minecraft.test_instance_block": "Khối trường hợp kiểm tra",
  "block.minecraft.tinted_glass": "Thủy tinh mờ",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Vụ nổ từ TNT đã bị tắt",
  "block.minecraft.torch": "Đuốc",
  "block.minecraft.torchflower": "Hoa đuốc",
  "block.minecraft.torchflower_crop": "Cây hoa đuốc",
  "block.minecraft.trapped_chest": "Rương gài bẫy",
  "block.minecraft.trial_spawner": "Lồng triệu hồi thử thách",
  "block.minecraft.tripwire": "Dây bẫy",
  "block.minecraft.tripwire_hook": "Móc dây bẫy",
  "block.minecraft.tube_coral": "San hô ống tròn",
  "block.minecraft.tube_coral_block": "Khối san hô ống tròn",
  "block.minecraft.tube_coral_fan": "San hô ống tròn hình quạt",
  "block.minecraft.tube_coral_wall_fan": "Cành san hô ống tròn hình quạt",
  "block.minecraft.tuff": "Đá túp",
  "block.minecraft.tuff_brick_slab": "Phiến gạch đá túp",
  "block.minecraft.tuff_brick_stairs": "Cầu thang gạch đá túp",
  "block.minecraft.tuff_brick_wall": "Tường gạch đá túp",
  "block.minecraft.tuff_bricks": "Gạch đá túp",
  "block.minecraft.tuff_slab": "Phiến đá túp",
  "block.minecraft.tuff_stairs": "Cầu thang đá túp",
  "block.minecraft.tuff_wall": "Tường đá túp",
  "block.minecraft.turtle_egg": "Trứng rùa",
  "block.minecraft.twisting_vines": "Dây leo xoắn",
  "block.minecraft.twisting_vines_plant": "Cây dây leo xoắn",
  "block.minecraft.vault": "Hòm báu vật",
  "block.minecraft.verdant_froglight": "Đèn ếch xanh cỏ tươi",
  "block.minecraft.vine": "Dây leo",
  "block.minecraft.void_air": "Không khí hư không",
  "block.minecraft.wall_torch": "Đuốc trên tường",
  "block.minecraft.warped_button": "Nút kì dị",
  "block.minecraft.warped_door": "Cửa kì dị",
  "block.minecraft.warped_fence": "Hàng rào kì dị",
  "block.minecraft.warped_fence_gate": "Cổng rào kì dị",
  "block.minecraft.warped_fungus": "Nấm kì dị",
  "block.minecraft.warped_hanging_sign": "Tấm biển treo kì dị",
  "block.minecraft.warped_hyphae": "Sợi nấm kì dị",
  "block.minecraft.warped_nylium": "Khuẩn dị thể kì dị",
  "block.minecraft.warped_planks": "Ván kì dị",
  "block.minecraft.warped_pressure_plate": "Tấm áp lực kì dị",
  "block.minecraft.warped_roots": "Rễ kì dị",
  "block.minecraft.warped_shelf": "Kệ kì dị",
  "block.minecraft.warped_sign": "Tấm biển kì dị",
  "block.minecraft.warped_slab": "Phiến kì dị",
  "block.minecraft.warped_stairs": "Cầu thang kì dị",
  "block.minecraft.warped_stem": "Cuống kì dị",
  "block.minecraft.warped_trapdoor": "Cửa sập kì dị",
  "block.minecraft.warped_wall_hanging_sign": "Tấm biển treo kì dị trên tường",
  "block.minecraft.warped_wall_sign": "Tấm biển kì dị trên tường",
  "block.minecraft.warped_wart_block": "Khối bướu kì dị",
  "block.minecraft.water": "Nước",
  "block.minecraft.water_cauldron": "Vạc nước",
  "block.minecraft.waxed_chiseled_copper": "Khối đồng được đục đã bôi sáp",
  "block.minecraft.waxed_copper_bars": "Hàng rào đồng đã bôi sáp",
  "block.minecraft.waxed_copper_block": "Khối đồng đã bôi sáp",
  "block.minecraft.waxed_copper_bulb": "Bóng đèn đồng đã bôi sáp",
  "block.minecraft.waxed_copper_chain": "Dây xích đồng đã bôi sáp",
  "block.minecraft.waxed_copper_chest": "Rương đồng đã bôi sáp",
  "block.minecraft.waxed_copper_door": "Cửa đồng đã bôi sáp",
  "block.minecraft.waxed_copper_golem_statue": "Tượng người đồng đã bôi sáp",
  "block.minecraft.waxed_copper_grate": "Lưới đồng đã bôi sáp",
  "block.minecraft.waxed_copper_lantern": "Đèn lồng đồng đã bôi sáp",
  "block.minecraft.waxed_copper_trapdoor": "Cửa sập đồng đã bôi sáp",
  "block.minecraft.waxed_cut_copper": "Khối đồng được cắt đã bôi sáp",
  "block.minecraft.waxed_cut_copper_slab": "Phiến đồng được cắt đã bôi sáp",
  "block.minecraft.waxed_cut_copper_stairs": "Cầu thang đồng được cắt đã bôi sáp",
  "block.minecraft.waxed_exposed_chiseled_copper": "Khối đồng được đục bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper": "Khối đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_bars": "Hàng rào đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_bulb": "Bóng đèn đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_chain": "Dây xích đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_chest": "Rương đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_door": "Cửa đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Tượng người đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_grate": "Lưới đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_lantern": "Đèn lồng đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Cửa sập đồng bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_cut_copper": "Khối đồng được cắt bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Phiến đồng được cắt bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Cầu thang đồng được cắt bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_exposed_lightning_rod": "Cột thu lôi bị phơi ra đã bôi sáp",
  "block.minecraft.waxed_lightning_rod": "Cột thu lôi đã bôi sáp",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Khối đồng được đục bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper": "Khối đồng bị oxi hóa đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_bars": "Hàng rào đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bóng đèn đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_chain": "Dây xích đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_chest": "Rương đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_door": "Cửa đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Tượng người đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_grate": "Lưới đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_lantern": "Đèn lồng đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Cửa sập đồng bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_cut_copper": "Khối đồng được cắt bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Phiến đồng được cắt bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Cầu thang đồng được cắt bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_oxidized_lightning_rod": "Cột thu lôi bị oxi hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_chiseled_copper": "Khối đồng được đục bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper": "Khối đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_bars": "Hàng rào đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_bulb": "Bóng đèn đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_chain": "Dây xích đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_chest": "Rương đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_door": "Cửa đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Tượng người đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_grate": "Lưới đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_lantern": "Đèn lồng đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Cửa sập đồng bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_cut_copper": "Khối đồng được cắt bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Phiến đồng được cắt bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Cầu thang đồng được cắt bị phong hoá đã bôi sáp",
  "block.minecraft.waxed_weathered_lightning_rod": "Cột thu lôi bị phong hoá đã bôi sáp",
  "block.minecraft.weathered_chiseled_copper": "Khối đồng được đục bị phong hoá",
  "block.minecraft.weathered_copper": "Khối đồng bị phong hoá",
  "block.minecraft.weathered_copper_bars": "Hàng rào đồng bị phong hoá",
  "block.minecraft.weathered_copper_bulb": "Bóng đèn đồng bị phong hoá",
  "block.minecraft.weathered_copper_chain": "Dây xích đồng bị phong hoá",
  "block.minecraft.weathered_copper_chest": "Rương đồng bị phong hoá",
  "block.minecraft.weathered_copper_door": "Cửa đồng bị phong hoá",
  "block.minecraft.weathered_copper_golem_statue": "Tượng người đồng bị phong hoá",
  "block.minecraft.weathered_copper_grate": "Lưới đồng bị phong hoá",
  "block.minecraft.weathered_copper_lantern": "Đèn lồng đồng bị phong hoá",
  "block.minecraft.weathered_copper_trapdoor": "Cửa sập đồng bị phong hoá",
  "block.minecraft.weathered_cut_copper": "Khối đồng được cắt bị phong hóa",
  "block.minecraft.weathered_cut_copper_slab": "Phiến đồng được cắt bị phong hoá",
  "block.minecraft.weathered_cut_copper_stairs": "Cầu thang đồng được cắt bị phong hóa",
  "block.minecraft.weathered_lightning_rod": "Cột thu lôi bị phong hoá",
  "block.minecraft.weeping_vines": "Dây leo đẫm máu",
  "block.minecraft.weeping_vines_plant": "Cây dây leo đẫm máu",
  "block.minecraft.wet_sponge": "Miếng bọt biển ướt",
  "block.minecraft.wheat": "Cây lúa mì",
  "block.minecraft.white_banner": "Cờ hiệu trắng",
  "block.minecraft.white_bed": "Giường trắng",
  "block.minecraft.white_candle": "Nến trắng",
  "block.minecraft.white_candle_cake": "Bánh ngọt có nến trắng",
  "block.minecraft.white_carpet": "Thảm trắng",
  "block.minecraft.white_concrete": "Bê tông trắng",
  "block.minecraft.white_concrete_powder": "Bột bê tông trắng",
  "block.minecraft.white_glazed_terracotta": "Đất nung tráng men trắng",
  "block.minecraft.white_shulker_box": "Hộp Shulker trắng",
  "block.minecraft.white_stained_glass": "Thủy tinh được nhuộm trắng",
  "block.minecraft.white_stained_glass_pane": "Tấm thủy tinh được nhuộm trắng",
  "block.minecraft.white_terracotta": "Đất nung trắng",
  "block.minecraft.white_tulip": "Uất kim hương trắng",
  "block.minecraft.white_wool": "Len trắng",
  "block.minecraft.wildflowers": "Hoa dại",
  "block.minecraft.wither_rose": "Hoa hồng Wither",
  "block.minecraft.wither_skeleton_skull": "Đầu lâu bộ xương Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Đầu lâu bộ xương Wither trên tường",
  "block.minecraft.yellow_banner": "Cờ hiệu vàng",
  "block.minecraft.yellow_bed": "Giường vàng",
  "block.minecraft.yellow_candle": "Nến vàng",
  "block.minecraft.yellow_candle_cake": "Bánh ngọt có nến vàng",
  "block.minecraft.yellow_carpet": "Thảm vàng",
  "block.minecraft.yellow_concrete": "Bê tông vàng",
  "block.minecraft.yellow_concrete_powder": "Bột bê tông vàng",
  "block.minecraft.yellow_glazed_terracotta": "Đất nung tráng men vàng",
  "block.minecraft.yellow_shulker_box": "Hộp Shulker vàng",
  "block.minecraft.yellow_stained_glass": "Thủy tinh được nhuộm vàng",
  "block.minecraft.yellow_stained_glass_pane": "Tấm thủy tinh được nhuộm vàng",
  "block.minecraft.yellow_terracotta": "Đất nung vàng",
  "block.minecraft.yellow_wool": "Len vàng",
  "block.minecraft.zombie_head": "Đầu thây ma",
  "block.minecraft.zombie_wall_head": "Đầu thây ma trên tường",
  "item.minecraft.acacia_boat": "Thuyền gỗ xiêm gai",
  "item.minecraft.acacia_chest_boat": "Thuyền gỗ xiêm gai có rương",
  "item.minecraft.allay_spawn_egg": "Trứng sinh ra Allay",
  "item.minecraft.amethyst_shard": "Mảnh thạch anh tím",
  "item.minecraft.angler_pottery_shard": "Mảnh gốm người câu cá",
  "item.minecraft.angler_pottery_sherd": "Mảnh gốm người câu cá",
  "item.minecraft.apple": "Táo",
  "item.minecraft.archer_pottery_shard": "Mảnh gốm cung thủ",
  "item.minecraft.archer_pottery_sherd": "Mảnh gốm cung thủ",
  "item.minecraft.armadillo_scute": "Vảy Tatu",
  "item.minecraft.armadillo_spawn_egg": "Trứng sinh ra Con Tatu",
  "item.minecraft.armor_stand": "Giá để giáp",
  "item.minecraft.arms_up_pottery_shard": "Mảnh gốm giơ tay",
  "item.minecraft.arms_up_pottery_sherd": "Mảnh gốm giơ tay",
  "item.minecraft.arrow": "Mũi tên",
  "item.minecraft.axolotl_bucket": "Xô Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Trứng sinh ra Axolotl",
  "item.minecraft.baked_potato": "Khoai tây bỏ lò",
  "item.minecraft.bamboo_chest_raft": "Bè gỗ tre có rương",
  "item.minecraft.bamboo_raft": "Bè gỗ tre",
  "item.minecraft.bat_spawn_egg": "Trứng sinh ra Con dơi",
  "item.minecraft.bee_spawn_egg": "Trứng sinh ra Con ong",
  "item.minecraft.beef": "Thịt bò sống",
  "item.minecraft.beetroot": "Củ dền",
  "item.minecraft.beetroot_seeds": "Hạt củ dền",
  "item.minecraft.beetroot_soup": "Súp củ dền",
  "item.minecraft.birch_boat": "Thuyền gỗ bạch dương",
  "item.minecraft.birch_chest_boat": "Thuyền gỗ bạch dương có rương",
  "item.minecraft.black_bundle": "Túi bọc đen",
  "item.minecraft.black_dye": "Bột nhuộm đen",
  "item.minecraft.black_harness": "Yên cương đen",
  "item.minecraft.blade_pottery_shard": "Mảnh gốm lưỡi kiếm",
  "item.minecraft.blade_pottery_sherd": "Mảnh gốm lưỡi kiếm",
  "item.minecraft.blaze_powder": "Bột quỷ lửa",
  "item.minecraft.blaze_rod": "Que lửa",
  "item.minecraft.blaze_spawn_egg": "Trứng sinh ra Quỷ lửa",
  "item.minecraft.blue_bundle": "Túi bọc xanh nước biển",
  "item.minecraft.blue_dye": "Bột nhuộm xanh nước biển",
  "item.minecraft.blue_egg": "Trứng xanh nước biển",
  "item.minecraft.blue_harness": "Yên cương xanh nước biển",
  "item.minecraft.bogged_spawn_egg": "Trứng sinh ra Quái đầm lầy",
  "item.minecraft.bolt_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Trang trí giáp kiểu bu lông",
  "item.minecraft.bone": "Xương",
  "item.minecraft.bone_meal": "Bột xương",
  "item.minecraft.book": "Quyển sách",
  "item.minecraft.bordure_indented_banner_pattern": "Hoa văn cờ hiệu đường răng cưa",
  "item.minecraft.bow": "Cung",
  "item.minecraft.bowl": "Cái bát",
  "item.minecraft.bread": "Bánh mì",
  "item.minecraft.breeze_rod": "Que gió",
  "item.minecraft.breeze_spawn_egg": "Trứng sinh ra Quỷ gió",
  "item.minecraft.brewer_pottery_shard": "Mảnh gốm lọ thuốc",
  "item.minecraft.brewer_pottery_sherd": "Mảnh gốm lọ thuốc",
  "item.minecraft.brewing_stand": "Giàn pha thuốc",
  "item.minecraft.brick": "Viên gạch",
  "item.minecraft.brown_bundle": "Túi bọc nâu",
  "item.minecraft.brown_dye": "Bột nhuộm nâu",
  "item.minecraft.brown_egg": "Trứng nâu",
  "item.minecraft.brown_harness": "Yên cương nâu",
  "item.minecraft.brush": "Chổi quét",
  "item.minecraft.bucket": "Xô",
  "item.minecraft.bundle": "Túi bọc",
  "item.minecraft.bundle.empty": "Trống",
  "item.minecraft.bundle.empty.description": "Có thể chứa một chồng vật phẩm hỗn hợp",
  "item.minecraft.bundle.full": "Đầy",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Mảnh gốm lửa cháy",
  "item.minecraft.burn_pottery_sherd": "Mảnh gốm lửa cháy",
  "item.minecraft.camel_husk_spawn_egg": "Trứng sinh ra Lạc đà khô tàn",
  "item.minecraft.camel_spawn_egg": "Trứng sinh ra Lạc đà",
  "item.minecraft.carrot": "Cà rốt",
  "item.minecraft.carrot_on_a_stick": "Cần câu gắn cà rốt",
  "item.minecraft.cat_spawn_egg": "Trứng sinh ra Con mèo",
  "item.minecraft.cauldron": "Cái vạc",
  "item.minecraft.cave_spider_spawn_egg": "Trứng sinh ra Nhện hang",
  "item.minecraft.chainmail_boots": "Ủng xích",
  "item.minecraft.chainmail_chestplate": "Áo xích",
  "item.minecraft.chainmail_helmet": "Mũ xích",
  "item.minecraft.chainmail_leggings": "Quần xích",
  "item.minecraft.charcoal": "Than gỗ",
  "item.minecraft.cherry_boat": "Thuyền gỗ anh đào",
  "item.minecraft.cherry_chest_boat": "Thuyền gỗ anh đào có rương",
  "item.minecraft.chest_minecart": "Xe mỏ có rương",
  "item.minecraft.chicken": "Thịt gà sống",
  "item.minecraft.chicken_spawn_egg": "Trứng sinh ra Con gà",
  "item.minecraft.chorus_fruit": "Quả Chorus",
  "item.minecraft.clay_ball": "Quả cầu đất sét",
  "item.minecraft.clock": "Đồng hồ",
  "item.minecraft.coal": "Than",
  "item.minecraft.coast_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Trang trí giáp kiểu bờ biển",
  "item.minecraft.cocoa_beans": "Hạt ca cao",
  "item.minecraft.cod": "Cá tuyết sống",
  "item.minecraft.cod_bucket": "Xô cá tuyết",
  "item.minecraft.cod_spawn_egg": "Trứng sinh ra Cá tuyết",
  "item.minecraft.command_block_minecart": "Xe mỏ có khối lệnh",
  "item.minecraft.compass": "La bàn",
  "item.minecraft.cooked_beef": "Bít tết",
  "item.minecraft.cooked_chicken": "Thịt gà chín",
  "item.minecraft.cooked_cod": "Cá tuyết chín",
  "item.minecraft.cooked_mutton": "Thịt cừu chín",
  "item.minecraft.cooked_porkchop": "Thịt heo chín",
  "item.minecraft.cooked_rabbit": "Thịt thỏ chín",
  "item.minecraft.cooked_salmon": "Cá hồi chín",
  "item.minecraft.cookie": "Bánh quy",
  "item.minecraft.copper_axe": "Rìu đồng",
  "item.minecraft.copper_boots": "Ủng đồng",
  "item.minecraft.copper_chestplate": "Áo đồng",
  "item.minecraft.copper_golem_spawn_egg": "Trứng sinh ra Người đồng",
  "item.minecraft.copper_helmet": "Mũ đồng",
  "item.minecraft.copper_hoe": "Cuốc đồng",
  "item.minecraft.copper_horse_armor": "Giáp ngựa đồng",
  "item.minecraft.copper_ingot": "Phôi đồng",
  "item.minecraft.copper_leggings": "Quần đồng",
  "item.minecraft.copper_nautilus_armor": "Giáp ốc anh vũ đồng",
  "item.minecraft.copper_nugget": "Hạt đồng",
  "item.minecraft.copper_pickaxe": "Cuốc chim đồng",
  "item.minecraft.copper_shovel": "Xẻng đồng",
  "item.minecraft.copper_spear": "Giáo đồng",
  "item.minecraft.copper_sword": "Kiếm đồng",
  "item.minecraft.cow_spawn_egg": "Trứng sinh ra Con bò",
  "item.minecraft.creaking_spawn_egg": "Trứng sinh ra Quái cọt kẹt",
  "item.minecraft.creeper_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.creeper_banner_pattern.desc": "Phù hiệu Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Hoa văn cờ hiệu phù hiệu Creeper",
  "item.minecraft.creeper_spawn_egg": "Trứng sinh ra Creeper",
  "item.minecraft.crossbow": "Cây nỏ",
  "item.minecraft.crossbow.projectile": "Vật bắn ra:",
  "item.minecraft.crossbow.projectile.multiple": "Vật bắn ra: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Vật bắn ra: %s",
  "item.minecraft.cyan_bundle": "Túi bọc lục lam",
  "item.minecraft.cyan_dye": "Bột nhuộm lục lam",
  "item.minecraft.cyan_harness": "Yên cương lục lam",
  "item.minecraft.danger_pottery_shard": "Mảnh gốm hiểm nguy",
  "item.minecraft.danger_pottery_sherd": "Mảnh gốm hiểm nguy",
  "item.minecraft.dark_oak_boat": "Thuyền gỗ sồi sẫm",
  "item.minecraft.dark_oak_chest_boat": "Thuyền gỗ sồi sẫm có rương",
  "item.minecraft.debug_stick": "Gậy gỡ lỗi",
  "item.minecraft.debug_stick.empty": "%s không có thuộc tính nào",
  "item.minecraft.debug_stick.select": "đã chọn \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" thành %s",
  "item.minecraft.diamond": "Kim cương",
  "item.minecraft.diamond_axe": "Rìu kim cương",
  "item.minecraft.diamond_boots": "Ủng kim cương",
  "item.minecraft.diamond_chestplate": "Áo kim cương",
  "item.minecraft.diamond_helmet": "Mũ kim cương",
  "item.minecraft.diamond_hoe": "Cuốc kim cương",
  "item.minecraft.diamond_horse_armor": "Giáp ngựa kim cương",
  "item.minecraft.diamond_leggings": "Quần kim cương",
  "item.minecraft.diamond_nautilus_armor": "Giáp ốc anh vũ kim cương",
  "item.minecraft.diamond_pickaxe": "Cuốc chim kim cương",
  "item.minecraft.diamond_shovel": "Xẻng kim cương",
  "item.minecraft.diamond_spear": "Giáo kim cương",
  "item.minecraft.diamond_sword": "Kiếm kim cương",
  "item.minecraft.disc_fragment_5": "Mảnh vỡ đĩa nhạc",
  "item.minecraft.disc_fragment_5.desc": "Đĩa nhạc - 5",
  "item.minecraft.dolphin_spawn_egg": "Trứng sinh ra Cá heo",
  "item.minecraft.donkey_spawn_egg": "Trứng sinh ra Con lừa",
  "item.minecraft.dragon_breath": "Hơi thở của rồng",
  "item.minecraft.dried_kelp": "Tảo bẹ khô",
  "item.minecraft.drowned_spawn_egg": "Trứng sinh ra Kẻ đuối nước",
  "item.minecraft.dune_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Trang trí giáp kiểu đụn cát",
  "item.minecraft.echo_shard": "Mảnh vỡ âm vang",
  "item.minecraft.egg": "Trứng",
  "item.minecraft.elder_guardian_spawn_egg": "Trứng sinh ra Giám hộ cao niên",
  "item.minecraft.elytra": "Cánh cứng",
  "item.minecraft.emerald": "Ngọc lục bảo",
  "item.minecraft.enchanted_book": "Sách được phù phép",
  "item.minecraft.enchanted_golden_apple": "Táo vàng được phù phép",
  "item.minecraft.end_crystal": "Pha lê End",
  "item.minecraft.ender_dragon_spawn_egg": "Trứng sinh ra Rồng Ender",
  "item.minecraft.ender_eye": "Mắt của Ender",
  "item.minecraft.ender_pearl": "Ngọc Ender",
  "item.minecraft.enderman_spawn_egg": "Trứng sinh ra Người Ender",
  "item.minecraft.endermite_spawn_egg": "Trứng sinh ra Endermite",
  "item.minecraft.evoker_spawn_egg": "Trứng sinh ra Kẻ chiêu hồn",
  "item.minecraft.experience_bottle": "Chai kinh nghiệm",
  "item.minecraft.explorer_pottery_shard": "Mảnh gốm khai phá",
  "item.minecraft.explorer_pottery_sherd": "Mảnh gốm khai phá",
  "item.minecraft.eye_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Trang trí giáp kiểu con mắt",
  "item.minecraft.feather": "Lông",
  "item.minecraft.fermented_spider_eye": "Mắt nhện được lên men",
  "item.minecraft.field_masoned_banner_pattern": "Hoa văn cờ hiệu phủ kín gạch",
  "item.minecraft.filled_map": "Bản đồ",
  "item.minecraft.fire_charge": "Cầu lửa",
  "item.minecraft.firework_rocket": "Pháo hoa",
  "item.minecraft.firework_rocket.flight": "Khoảng thời gian bay:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Bông pháo hoa",
  "item.minecraft.firework_star.black": "Màu đen",
  "item.minecraft.firework_star.blue": "Màu xanh nước biển",
  "item.minecraft.firework_star.brown": "Màu nâu",
  "item.minecraft.firework_star.custom_color": "Tuỳ chỉnh",
  "item.minecraft.firework_star.cyan": "Màu lục lam",
  "item.minecraft.firework_star.fade_to": "Phai thành",
  "item.minecraft.firework_star.flicker": "Lấp lánh",
  "item.minecraft.firework_star.gray": "Màu xám",
  "item.minecraft.firework_star.green": "Màu xanh lá cây",
  "item.minecraft.firework_star.light_blue": "Màu xanh nước biển nhạt",
  "item.minecraft.firework_star.light_gray": "Màu xám nhạt",
  "item.minecraft.firework_star.lime": "Màu xanh lá mạ",
  "item.minecraft.firework_star.magenta": "Màu đỏ sậm",
  "item.minecraft.firework_star.orange": "Màu cam",
  "item.minecraft.firework_star.pink": "Màu hồng",
  "item.minecraft.firework_star.purple": "Màu tím",
  "item.minecraft.firework_star.red": "Màu đỏ",
  "item.minecraft.firework_star.shape": "Hình dạng không rõ",
  "item.minecraft.firework_star.shape.burst": "Hình chùm",
  "item.minecraft.firework_star.shape.creeper": "Hình Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Hình cầu lớn",
  "item.minecraft.firework_star.shape.small_ball": "Hình cầu nhỏ",
  "item.minecraft.firework_star.shape.star": "Hình ngôi sao",
  "item.minecraft.firework_star.trail": "Đường bay",
  "item.minecraft.firework_star.white": "Màu trắng",
  "item.minecraft.firework_star.yellow": "Màu vàng",
  "item.minecraft.fishing_rod": "Cần câu cá",
  "item.minecraft.flint": "Đá lửa",
  "item.minecraft.flint_and_steel": "Dụng cụ đánh lửa",
  "item.minecraft.flow_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Trang trí giáp kiểu làn gió",
  "item.minecraft.flow_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.flow_banner_pattern.desc": "Làn gió",
  "item.minecraft.flow_banner_pattern.new": "Hoa văn cờ hiệu làn gió",
  "item.minecraft.flow_pottery_sherd": "Mảnh gốm làn gió",
  "item.minecraft.flower_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.flower_banner_pattern.desc": "Phù hiệu hoa",
  "item.minecraft.flower_banner_pattern.new": "Hoa văn cờ hiệu phù hiệu hoa",
  "item.minecraft.flower_pot": "Chậu hoa",
  "item.minecraft.fox_spawn_egg": "Trứng sinh ra Con cáo",
  "item.minecraft.friend_pottery_shard": "Mảnh gốm người bạn",
  "item.minecraft.friend_pottery_sherd": "Mảnh gốm người bạn",
  "item.minecraft.frog_spawn_egg": "Trứng sinh ra Con ếch",
  "item.minecraft.furnace_minecart": "Xe mỏ có lò nung",
  "item.minecraft.ghast_spawn_egg": "Trứng sinh ra Ghast",
  "item.minecraft.ghast_tear": "Nước mắt Ghast",
  "item.minecraft.glass_bottle": "Chai thuỷ tinh",
  "item.minecraft.glistering_melon_slice": "Lát cắt dưa hấu lấp lánh",
  "item.minecraft.globe_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.globe_banner_pattern.desc": "Địa cầu",
  "item.minecraft.globe_banner_pattern.new": "Hoa văn cờ hiệu địa cầu",
  "item.minecraft.glow_berries": "Quả mọng phát sáng",
  "item.minecraft.glow_ink_sac": "Túi mực phát sáng",
  "item.minecraft.glow_item_frame": "Khung vật phẩm phát sáng",
  "item.minecraft.glow_squid_spawn_egg": "Trứng sinh ra Mực phát sáng",
  "item.minecraft.glowstone_dust": "Bột đá phát sáng",
  "item.minecraft.goat_horn": "Sừng dê",
  "item.minecraft.goat_spawn_egg": "Trứng sinh ra Con dê",
  "item.minecraft.gold_ingot": "Phôi vàng",
  "item.minecraft.gold_nugget": "Hạt vàng",
  "item.minecraft.golden_apple": "Táo vàng",
  "item.minecraft.golden_axe": "Rìu vàng",
  "item.minecraft.golden_boots": "Ủng vàng",
  "item.minecraft.golden_carrot": "Cà rốt vàng",
  "item.minecraft.golden_chestplate": "Áo vàng",
  "item.minecraft.golden_helmet": "Mũ vàng",
  "item.minecraft.golden_hoe": "Cuốc vàng",
  "item.minecraft.golden_horse_armor": "Giáp ngựa vàng",
  "item.minecraft.golden_leggings": "Quần vàng",
  "item.minecraft.golden_nautilus_armor": "Giáp ốc anh vũ vàng",
  "item.minecraft.golden_pickaxe": "Cuốc chim vàng",
  "item.minecraft.golden_shovel": "Xẻng vàng",
  "item.minecraft.golden_spear": "Giáo vàng",
  "item.minecraft.golden_sword": "Kiếm vàng",
  "item.minecraft.gray_bundle": "Túi bọc xám",
  "item.minecraft.gray_dye": "Bột nhuộm xám",
  "item.minecraft.gray_harness": "Yên cương xám",
  "item.minecraft.green_bundle": "Túi bọc xanh lá cây",
  "item.minecraft.green_dye": "Bột nhuộm xanh lá cây",
  "item.minecraft.green_harness": "Yên cương xanh lá cây",
  "item.minecraft.guardian_spawn_egg": "Trứng sinh ra Giám hộ",
  "item.minecraft.gunpowder": "Thuốc súng",
  "item.minecraft.guster_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.guster_banner_pattern.desc": "Gió dữ",
  "item.minecraft.guster_banner_pattern.new": "Hoa văn cờ hiệu gió dữ",
  "item.minecraft.guster_pottery_sherd": "Mảnh gốm gió dữ",
  "item.minecraft.happy_ghast_spawn_egg": "Trứng sinh ra Ghast vui vẻ",
  "item.minecraft.harness": "Yên cương",
  "item.minecraft.heart_of_the_sea": "Trái tim biển cả",
  "item.minecraft.heart_pottery_shard": "Mảnh gốm trái tim",
  "item.minecraft.heart_pottery_sherd": "Mảnh gốm trái tim",
  "item.minecraft.heartbreak_pottery_shard": "Mảnh gốm trái tim tan vỡ",
  "item.minecraft.heartbreak_pottery_sherd": "Mảnh gốm trái tim tan vỡ",
  "item.minecraft.hoglin_spawn_egg": "Trứng sinh ra Hoglin",
  "item.minecraft.honey_bottle": "Chai mật ong",
  "item.minecraft.honeycomb": "Sáp ong",
  "item.minecraft.hopper_minecart": "Xe mỏ có phễu",
  "item.minecraft.horse_spawn_egg": "Trứng sinh ra Con ngựa",
  "item.minecraft.host_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.host_armor_trim_smithing_template.new": "Trang trí giáp kiểu người chủ",
  "item.minecraft.howl_pottery_shard": "Mảnh gốm sói hú",
  "item.minecraft.howl_pottery_sherd": "Mảnh gốm sói hú",
  "item.minecraft.husk_spawn_egg": "Trứng sinh ra Quái khô tàn",
  "item.minecraft.ink_sac": "Túi mực",
  "item.minecraft.iron_axe": "Rìu sắt",
  "item.minecraft.iron_boots": "Ủng sắt",
  "item.minecraft.iron_chestplate": "Áo sắt",
  "item.minecraft.iron_golem_spawn_egg": "Trứng sinh ra Người sắt",
  "item.minecraft.iron_helmet": "Mũ sắt",
  "item.minecraft.iron_hoe": "Cuốc sắt",
  "item.minecraft.iron_horse_armor": "Giáp ngựa sắt",
  "item.minecraft.iron_ingot": "Phôi sắt",
  "item.minecraft.iron_leggings": "Quần sắt",
  "item.minecraft.iron_nautilus_armor": "Giáp ốc anh vũ sắt",
  "item.minecraft.iron_nugget": "Hạt sắt",
  "item.minecraft.iron_pickaxe": "Cuốc chim sắt",
  "item.minecraft.iron_shovel": "Xẻng sắt",
  "item.minecraft.iron_spear": "Giáo sắt",
  "item.minecraft.iron_sword": "Kiếm sắt",
  "item.minecraft.item_frame": "Khung vật phẩm",
  "item.minecraft.jungle_boat": "Thuyền gỗ rừng",
  "item.minecraft.jungle_chest_boat": "Thuyền gỗ rừng có rương",
  "item.minecraft.knowledge_book": "Sách kiến thức",
  "item.minecraft.lapis_lazuli": "Ngọc lưu ly",
  "item.minecraft.lava_bucket": "Xô dung nham",
  "item.minecraft.lead": "Dây buộc",
  "item.minecraft.leather": "Da thuộc",
  "item.minecraft.leather_boots": "Ủng da",
  "item.minecraft.leather_chestplate": "Áo da",
  "item.minecraft.leather_helmet": "Mũ da",
  "item.minecraft.leather_horse_armor": "Giáp ngựa da",
  "item.minecraft.leather_leggings": "Quần da",
  "item.minecraft.light_blue_bundle": "Túi bọc xanh nước biển nhạt",
  "item.minecraft.light_blue_dye": "Bột nhuộm xanh nhạt",
  "item.minecraft.light_blue_harness": "Yên cương xanh nước biển nhạt",
  "item.minecraft.light_gray_bundle": "Túi bọc xám nhạt",
  "item.minecraft.light_gray_dye": "Bột nhuộm xám nhạt",
  "item.minecraft.light_gray_harness": "Yên cương xám nhạt",
  "item.minecraft.lime_bundle": "Túi bọc xanh lá mạ",
  "item.minecraft.lime_dye": "Bột nhuộm xanh lá mạ",
  "item.minecraft.lime_harness": "Yên cương xanh lá mạ",
  "item.minecraft.lingering_potion": "Thuốc kéo dài",
  "item.minecraft.lingering_potion.effect.awkward": "Thuốc kì quặc kéo dài",
  "item.minecraft.lingering_potion.effect.empty": "Thuốc không thể tạo ra kéo dài",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Thuốc kháng lửa kéo dài",
  "item.minecraft.lingering_potion.effect.harming": "Thuốc sát thương kéo dài",
  "item.minecraft.lingering_potion.effect.healing": "Thuốc hồi máu kéo dài",
  "item.minecraft.lingering_potion.effect.infested": "Thuốc nhiễm khuẩn kéo dài",
  "item.minecraft.lingering_potion.effect.invisibility": "Thuốc tàng hình kéo dài",
  "item.minecraft.lingering_potion.effect.leaping": "Thuốc nhảy cao kéo dài",
  "item.minecraft.lingering_potion.effect.levitation": "Thuốc bay lên kéo dài",
  "item.minecraft.lingering_potion.effect.luck": "Thuốc may mắn kéo dài",
  "item.minecraft.lingering_potion.effect.mundane": "Thuốc trần tục kéo dài",
  "item.minecraft.lingering_potion.effect.night_vision": "Thuốc nhìn trong bóng tối kéo dài",
  "item.minecraft.lingering_potion.effect.oozing": "Thuốc rò rỉ kéo dài",
  "item.minecraft.lingering_potion.effect.poison": "Thuốc độc kéo dài",
  "item.minecraft.lingering_potion.effect.regeneration": "Thuốc hồi phục kéo dài",
  "item.minecraft.lingering_potion.effect.slow_falling": "Thuốc rơi chậm kéo dài",
  "item.minecraft.lingering_potion.effect.slowness": "Thuốc chậm rãi kéo dài",
  "item.minecraft.lingering_potion.effect.strength": "Thuốc sức mạnh kéo dài",
  "item.minecraft.lingering_potion.effect.swiftness": "Thuốc nhanh nhẹn kéo dài",
  "item.minecraft.lingering_potion.effect.thick": "Thuốc đặc kéo dài",
  "item.minecraft.lingering_potion.effect.turtle_master": "Thuốc kéo dài của Rùa cụ",
  "item.minecraft.lingering_potion.effect.water": "Chai nước kéo dài",
  "item.minecraft.lingering_potion.effect.water_breathing": "Thuốc thở dưới nước kéo dài",
  "item.minecraft.lingering_potion.effect.weakness": "Thuốc yếu đuối kéo dài",
  "item.minecraft.lingering_potion.effect.weaving": "Thuốc thêu dệt kéo dài",
  "item.minecraft.lingering_potion.effect.wind_charged": "Thuốc nạp gió kéo dài",
  "item.minecraft.llama_spawn_egg": "Trứng sinh ra Lạc đà không bướu",
  "item.minecraft.lodestone_compass": "La bàn đá nam châm",
  "item.minecraft.mace": "Chuỳ",
  "item.minecraft.magenta_bundle": "Túi bọc đỏ sậm",
  "item.minecraft.magenta_dye": "Bột nhuộm đỏ sậm",
  "item.minecraft.magenta_harness": "Yên cương đỏ sậm",
  "item.minecraft.magma_cream": "Kem dung nham",
  "item.minecraft.magma_cube_spawn_egg": "Trứng sinh ra Khối dung nham",
  "item.minecraft.mangrove_boat": "Thuyền gỗ đước",
  "item.minecraft.mangrove_chest_boat": "Thuyền gỗ đước có rương",
  "item.minecraft.map": "Bản đồ trống",
  "item.minecraft.melon_seeds": "Hạt dưa hấu",
  "item.minecraft.melon_slice": "Lát cắt dưa hấu",
  "item.minecraft.milk_bucket": "Xô sữa",
  "item.minecraft.minecart": "Xe mỏ",
  "item.minecraft.miner_pottery_shard": "Mảnh gốm thợ mỏ",
  "item.minecraft.miner_pottery_sherd": "Mảnh gốm thợ mỏ",
  "item.minecraft.mojang_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.mojang_banner_pattern.desc": "Vật thể",
  "item.minecraft.mojang_banner_pattern.new": "Hoa văn cờ hiệu vật thể",
  "item.minecraft.mooshroom_spawn_egg": "Trứng sinh ra Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Mảnh gốm than khóc",
  "item.minecraft.mourner_pottery_sherd": "Mảnh gốm người than khóc",
  "item.minecraft.mule_spawn_egg": "Trứng sinh ra Con la",
  "item.minecraft.mushroom_stew": "Súp nấm",
  "item.minecraft.music_disc_11": "Đĩa nhạc",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Đĩa nhạc",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Đĩa nhạc",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Đĩa nhạc",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Đĩa nhạc",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Đĩa nhạc",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Đĩa nhạc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Đĩa nhạc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Hộp nhạc)",
  "item.minecraft.music_disc_far": "Đĩa nhạc",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Đĩa nhạc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Đĩa nhạc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Đĩa nhạc",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Đĩa nhạc",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Đĩa nhạc",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Đĩa nhạc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Đĩa nhạc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Đĩa nhạc",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Đĩa nhạc",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Đĩa nhạc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Đĩa nhạc",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Đĩa nhạc",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Thịt cừu sống",
  "item.minecraft.name_tag": "Nhãn ghi tên",
  "item.minecraft.nautilus_shell": "Vỏ ốc anh vũ",
  "item.minecraft.nautilus_spawn_egg": "Trứng sinh ra Ốc anh vũ",
  "item.minecraft.nether_brick": "Viên gạch Nether",
  "item.minecraft.nether_star": "Sao Nether",
  "item.minecraft.nether_wart": "Bướu Nether",
  "item.minecraft.netherite_axe": "Rìu Netherit",
  "item.minecraft.netherite_boots": "Ủng Netherit",
  "item.minecraft.netherite_chestplate": "Áo Netherit",
  "item.minecraft.netherite_helmet": "Mũ Netherit",
  "item.minecraft.netherite_hoe": "Cuốc Netherit",
  "item.minecraft.netherite_horse_armor": "Giáp ngựa Netherit",
  "item.minecraft.netherite_ingot": "Phôi Netherit",
  "item.minecraft.netherite_leggings": "Quần Netherit",
  "item.minecraft.netherite_nautilus_armor": "Giáp ốc anh vũ Netherit",
  "item.minecraft.netherite_pickaxe": "Cuốc chim Netherit",
  "item.minecraft.netherite_scrap": "Vụn Netherit",
  "item.minecraft.netherite_shovel": "Xẻng Netherit",
  "item.minecraft.netherite_spear": "Giáo Netherit",
  "item.minecraft.netherite_sword": "Kiếm Netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Mẫu rèn",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Nâng cấp Netherit",
  "item.minecraft.oak_boat": "Thuyền gỗ sồi",
  "item.minecraft.oak_chest_boat": "Thuyền gỗ sồi có rương",
  "item.minecraft.ocelot_spawn_egg": "Trứng sinh ra Mèo rừng",
  "item.minecraft.ominous_bottle": "Chai điềm báo",
  "item.minecraft.ominous_trial_key": "Chìa khoá thử thách báo điềm",
  "item.minecraft.orange_bundle": "Túi bọc cam",
  "item.minecraft.orange_dye": "Bột nhuộm cam",
  "item.minecraft.orange_harness": "Yên cương cam",
  "item.minecraft.painting": "Tranh vẽ",
  "item.minecraft.pale_oak_boat": "Thuyền gỗ sồi nhợt",
  "item.minecraft.pale_oak_chest_boat": "Thuyền gỗ sồi nhợt có rương",
  "item.minecraft.panda_spawn_egg": "Trứng sinh ra Gấu trúc",
  "item.minecraft.paper": "Giấy",
  "item.minecraft.parched_spawn_egg": "Trứng sinh ra Kẻ khô độc",
  "item.minecraft.parrot_spawn_egg": "Trứng sinh ra Con vẹt",
  "item.minecraft.phantom_membrane": "Màng da Phantom",
  "item.minecraft.phantom_spawn_egg": "Trứng sinh ra Phantom",
  "item.minecraft.pig_spawn_egg": "Trứng sinh ra Con heo",
  "item.minecraft.piglin_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.piglin_banner_pattern.desc": "Mũi heo",
  "item.minecraft.piglin_banner_pattern.new": "Hoa văn cờ hiệu mũi heo",
  "item.minecraft.piglin_brute_spawn_egg": "Trứng sinh ra Piglin hung bạo",
  "item.minecraft.piglin_spawn_egg": "Trứng sinh ra Piglin",
  "item.minecraft.pillager_spawn_egg": "Trứng sinh ra Kẻ cướp",
  "item.minecraft.pink_bundle": "Túi bọc hồng",
  "item.minecraft.pink_dye": "Bột nhuộm hồng",
  "item.minecraft.pink_harness": "Yên cương hồng",
  "item.minecraft.pitcher_plant": "Cây nắp ấm",
  "item.minecraft.pitcher_pod": "Quả đậu nắp ấm",
  "item.minecraft.plenty_pottery_shard": "Mảnh gốm dồi dào",
  "item.minecraft.plenty_pottery_sherd": "Mảnh gốm dồi dào",
  "item.minecraft.poisonous_potato": "Khoai tây độc",
  "item.minecraft.polar_bear_spawn_egg": "Trứng sinh ra Gấu bắc cực",
  "item.minecraft.popped_chorus_fruit": "Quả Chorus nở bung",
  "item.minecraft.porkchop": "Thịt heo sống",
  "item.minecraft.potato": "Khoai tây",
  "item.minecraft.potion": "Thuốc",
  "item.minecraft.potion.effect.awkward": "Thuốc kì quặc",
  "item.minecraft.potion.effect.empty": "Thuốc không tạo ra được",
  "item.minecraft.potion.effect.fire_resistance": "Thuốc kháng lửa",
  "item.minecraft.potion.effect.harming": "Thuốc sát thương",
  "item.minecraft.potion.effect.healing": "Thuốc hồi máu",
  "item.minecraft.potion.effect.infested": "Thuốc nhiễm khuẩn",
  "item.minecraft.potion.effect.invisibility": "Thuốc tàng hình",
  "item.minecraft.potion.effect.leaping": "Thuốc nhảy cao",
  "item.minecraft.potion.effect.levitation": "Thuốc bay lên",
  "item.minecraft.potion.effect.luck": "Thuốc may mắn",
  "item.minecraft.potion.effect.mundane": "Thuốc trần tục",
  "item.minecraft.potion.effect.night_vision": "Thuốc nhìn trong bóng tối",
  "item.minecraft.potion.effect.oozing": "Thuốc rò rỉ",
  "item.minecraft.potion.effect.poison": "Thuốc độc",
  "item.minecraft.potion.effect.regeneration": "Thuốc hồi phục",
  "item.minecraft.potion.effect.slow_falling": "Thuốc rơi chậm",
  "item.minecraft.potion.effect.slowness": "Thuốc chậm rãi",
  "item.minecraft.potion.effect.strength": "Thuốc sức mạnh",
  "item.minecraft.potion.effect.swiftness": "Thuốc nhanh nhẹn",
  "item.minecraft.potion.effect.thick": "Thuốc đặc",
  "item.minecraft.potion.effect.turtle_master": "Thuốc của Rùa cụ",
  "item.minecraft.potion.effect.water": "Chai nước",
  "item.minecraft.potion.effect.water_breathing": "Thuốc thở dưới nước",
  "item.minecraft.potion.effect.weakness": "Thuốc yếu đuối",
  "item.minecraft.potion.effect.weaving": "Thuốc thêu dệt",
  "item.minecraft.potion.effect.wind_charged": "Thuốc nạp gió",
  "item.minecraft.pottery_shard_archer": "Mảnh gốm cung thủ",
  "item.minecraft.pottery_shard_arms_up": "Mảnh gốm giơ tay",
  "item.minecraft.pottery_shard_prize": "Mảnh gốm phần thưởng",
  "item.minecraft.pottery_shard_skull": "Mảnh gốm hộp sọ",
  "item.minecraft.powder_snow_bucket": "Xô bột tuyết",
  "item.minecraft.prismarine_crystals": "Tinh thể Prismarin",
  "item.minecraft.prismarine_shard": "Mảnh Prismarin",
  "item.minecraft.prize_pottery_shard": "Mảnh gốm phần thưởng",
  "item.minecraft.prize_pottery_sherd": "Mảnh gốm phần thưởng",
  "item.minecraft.pufferfish": "Cá nóc",
  "item.minecraft.pufferfish_bucket": "Xô cá nóc",
  "item.minecraft.pufferfish_spawn_egg": "Trứng sinh ra Cá nóc",
  "item.minecraft.pumpkin_pie": "Bánh bí ngô",
  "item.minecraft.pumpkin_seeds": "Hạt bí ngô",
  "item.minecraft.purple_bundle": "Túi bọc tím",
  "item.minecraft.purple_dye": "Bột nhuộm tím",
  "item.minecraft.purple_harness": "Yên cương tím",
  "item.minecraft.quartz": "Thạch anh Nether",
  "item.minecraft.rabbit": "Thịt thỏ sống",
  "item.minecraft.rabbit_foot": "Chân thỏ",
  "item.minecraft.rabbit_hide": "Da thỏ",
  "item.minecraft.rabbit_spawn_egg": "Trứng sinh ra Con thỏ",
  "item.minecraft.rabbit_stew": "Súp thỏ hầm",
  "item.minecraft.raiser_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Trang trí giáp kiểu người chăn nuôi",
  "item.minecraft.ravager_spawn_egg": "Trứng sinh ra Quái thú cướp bóc",
  "item.minecraft.raw_copper": "Đồng thô",
  "item.minecraft.raw_gold": "Vàng thô",
  "item.minecraft.raw_iron": "Sắt thô",
  "item.minecraft.recovery_compass": "La bàn hồi phục",
  "item.minecraft.red_bundle": "Túi bọc đỏ",
  "item.minecraft.red_dye": "Bột nhuộm đỏ",
  "item.minecraft.red_harness": "Yên cương đỏ",
  "item.minecraft.redstone": "Bột Redstone",
  "item.minecraft.resin_brick": "Viên gạch nhựa cây",
  "item.minecraft.resin_clump": "Cục nhựa cây",
  "item.minecraft.rib_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Trang trí giáp kiểu xương gọng",
  "item.minecraft.rotten_flesh": "Thịt thối rữa",
  "item.minecraft.saddle": "Yên cưỡi",
  "item.minecraft.salmon": "Cá hồi sống",
  "item.minecraft.salmon_bucket": "Xô cá hồi",
  "item.minecraft.salmon_spawn_egg": "Trứng sinh ra Cá hồi",
  "item.minecraft.scrape_pottery_sherd": "Mảnh gốm cạo vét",
  "item.minecraft.scute": "Vảy",
  "item.minecraft.sentry_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Trang trí giáp kiểu lính gác",
  "item.minecraft.shaper_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Trang trí giáp kiểu thợ nặn",
  "item.minecraft.sheaf_pottery_shard": "Mảnh gốm bó hoa",
  "item.minecraft.sheaf_pottery_sherd": "Mảnh gốm bó hoa",
  "item.minecraft.shears": "Kéo tỉa",
  "item.minecraft.sheep_spawn_egg": "Trứng sinh ra Con cừu",
  "item.minecraft.shelter_pottery_shard": "Mảnh gốm ẩn náu",
  "item.minecraft.shelter_pottery_sherd": "Mảnh gốm chỗ ẩn náu",
  "item.minecraft.shield": "Khiên",
  "item.minecraft.shield.black": "Khiên đen",
  "item.minecraft.shield.blue": "Khiên xanh nước biển",
  "item.minecraft.shield.brown": "Khiên nâu",
  "item.minecraft.shield.cyan": "Khiên lục lam",
  "item.minecraft.shield.gray": "Khiên xám",
  "item.minecraft.shield.green": "Khiên xanh lá cây",
  "item.minecraft.shield.light_blue": "Khiên xanh nước biển nhạt",
  "item.minecraft.shield.light_gray": "Khiên xám nhạt",
  "item.minecraft.shield.lime": "Khiên xanh lá mạ",
  "item.minecraft.shield.magenta": "Khiên đỏ sậm",
  "item.minecraft.shield.orange": "Khiên cam",
  "item.minecraft.shield.pink": "Khiên hồng",
  "item.minecraft.shield.purple": "Khiên tím",
  "item.minecraft.shield.red": "Khiên đỏ",
  "item.minecraft.shield.white": "Khiên trắng",
  "item.minecraft.shield.yellow": "Khiên vàng",
  "item.minecraft.shulker_shell": "Vỏ Shulker",
  "item.minecraft.shulker_spawn_egg": "Trứng sinh ra Shulker",
  "item.minecraft.sign": "Tấm biển",
  "item.minecraft.silence_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Trang trí giáp kiểu im lặng",
  "item.minecraft.silverfish_spawn_egg": "Trứng sinh ra Con nhậy bạc",
  "item.minecraft.skeleton_horse_spawn_egg": "Trứng sinh ra Ngựa xương",
  "item.minecraft.skeleton_spawn_egg": "Trứng sinh ra Bộ xương",
  "item.minecraft.skull_banner_pattern": "Hoa văn cờ hiệu",
  "item.minecraft.skull_banner_pattern.desc": "Phù hiệu đầu lâu",
  "item.minecraft.skull_banner_pattern.new": "Hoa văn cờ hiệu phù hiệu đầu lâu",
  "item.minecraft.skull_pottery_shard": "Mảnh gốm hộp sọ",
  "item.minecraft.skull_pottery_sherd": "Mảnh gốm đầu lâu",
  "item.minecraft.slime_ball": "Bóng nhờn",
  "item.minecraft.slime_spawn_egg": "Trứng sinh ra Quái vật chất nhờn",
  "item.minecraft.smithing_template": "Mẫu rèn",
  "item.minecraft.smithing_template.applies_to": "Áp dụng cho:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Thêm phôi hoặc tinh thể",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Giáp",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Thêm một mảnh giáp",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Phôi & tinh thể",
  "item.minecraft.smithing_template.ingredients": "Nguyên liệu:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Thêm phôi Netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Trang bị kim cương",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Thêm giáp, vũ khí, hoặc công cụ kim cương",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Phôi Netherit",
  "item.minecraft.smithing_template.upgrade": "Nâng cấp: ",
  "item.minecraft.sniffer_spawn_egg": "Trứng sinh ra Kẻ đánh hơi",
  "item.minecraft.snort_pottery_shard": "Mảnh gốm ống hơi",
  "item.minecraft.snort_pottery_sherd": "Mảnh gốm ống hơi",
  "item.minecraft.snout_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Trang trí giáp kiểu mũi heo",
  "item.minecraft.snow_golem_spawn_egg": "Trứng sinh ra Người tuyết",
  "item.minecraft.snowball": "Bóng tuyết",
  "item.minecraft.spectral_arrow": "Mũi tên ma quỷ",
  "item.minecraft.spider_eye": "Mắt nhện",
  "item.minecraft.spider_spawn_egg": "Trứng sinh ra Nhện",
  "item.minecraft.spire_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Trang trí giáp kiểu xoắn ốc",
  "item.minecraft.splash_potion": "Thuốc có thể ném được",
  "item.minecraft.splash_potion.effect.awkward": "Thuốc kì quặc có thể ném được",
  "item.minecraft.splash_potion.effect.empty": "Thuốc không thể tạo ra có thể ném được",
  "item.minecraft.splash_potion.effect.fire_resistance": "Thuốc kháng lửa có thể ném được",
  "item.minecraft.splash_potion.effect.harming": "Thuốc sát thương có thể ném được",
  "item.minecraft.splash_potion.effect.healing": "Thuốc hồi máu có thể ném được",
  "item.minecraft.splash_potion.effect.infested": "Thuốc nhiễm khuẩn có thể ném được",
  "item.minecraft.splash_potion.effect.invisibility": "Thuốc tàng hình có thể ném được",
  "item.minecraft.splash_potion.effect.leaping": "Thuốc nhảy cao có thể ném được",
  "item.minecraft.splash_potion.effect.levitation": "Thuốc bay lên có thể ném được",
  "item.minecraft.splash_potion.effect.luck": "Thuốc may mắn có thể ném được",
  "item.minecraft.splash_potion.effect.mundane": "Thuốc trần tục có thể ném được",
  "item.minecraft.splash_potion.effect.night_vision": "Thuốc nhìn trong bóng tối có thể ném được",
  "item.minecraft.splash_potion.effect.oozing": "Thuốc rò rỉ có thể ném được",
  "item.minecraft.splash_potion.effect.poison": "Thuốc độc có thể ném được",
  "item.minecraft.splash_potion.effect.regeneration": "Thuốc hồi phục có thể ném được",
  "item.minecraft.splash_potion.effect.slow_falling": "Thuốc rơi chậm có thể ném được",
  "item.minecraft.splash_potion.effect.slowness": "Thuốc chậm rãi có thể ném được",
  "item.minecraft.splash_potion.effect.strength": "Thuốc sức mạnh có thể ném được",
  "item.minecraft.splash_potion.effect.swiftness": "Thuốc nhanh nhẹn có thể ném được",
  "item.minecraft.splash_potion.effect.thick": "Thuốc đặc có thể ném được",
  "item.minecraft.splash_potion.effect.turtle_master": "Thuốc của Rùa cụ có thể ném được",
  "item.minecraft.splash_potion.effect.water": "Chai nước có thể ném được",
  "item.minecraft.splash_potion.effect.water_breathing": "Thuốc thở dưới nước có thể ném được",
  "item.minecraft.splash_potion.effect.weakness": "Thuốc yếu đuối có thể ném được",
  "item.minecraft.splash_potion.effect.weaving": "Thuốc thêu dệt có thể ném được",
  "item.minecraft.splash_potion.effect.wind_charged": "Thuốc nạp gió có thể ném được",
  "item.minecraft.spruce_boat": "Thuyền gỗ vân sam",
  "item.minecraft.spruce_chest_boat": "Thuyền gỗ vân sam có rương",
  "item.minecraft.spyglass": "Ống nhòm",
  "item.minecraft.squid_spawn_egg": "Trứng sinh ra Con mực",
  "item.minecraft.stick": "Gậy",
  "item.minecraft.stone_axe": "Rìu đá",
  "item.minecraft.stone_hoe": "Cuốc đá",
  "item.minecraft.stone_pickaxe": "Cuốc chim đá",
  "item.minecraft.stone_shovel": "Xẻng đá",
  "item.minecraft.stone_spear": "Giáo đá",
  "item.minecraft.stone_sword": "Kiếm đá",
  "item.minecraft.stray_spawn_egg": "Trứng sinh ra Quái lang thang",
  "item.minecraft.strider_spawn_egg": "Trứng sinh ra Kẻ sải bước",
  "item.minecraft.string": "Sợi chỉ",
  "item.minecraft.sugar": "Đường",
  "item.minecraft.suspicious_stew": "Súp đáng ngờ",
  "item.minecraft.sweet_berries": "Quả mọng ngọt",
  "item.minecraft.tadpole_bucket": "Xô nòng nọc",
  "item.minecraft.tadpole_spawn_egg": "Trứng sinh ra Nòng nọc",
  "item.minecraft.tide_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Trang trí giáp kiểu thuỷ triều",
  "item.minecraft.tipped_arrow": "Mũi tên tẩm thuốc",
  "item.minecraft.tipped_arrow.effect.awkward": "Mũi tên tẩm thuốc",
  "item.minecraft.tipped_arrow.effect.empty": "Mũi tên tẩm thuốc không chế tạo được",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Mũi tên kháng lửa",
  "item.minecraft.tipped_arrow.effect.harming": "Mũi tên sát thương",
  "item.minecraft.tipped_arrow.effect.healing": "Mũi tên hồi máu",
  "item.minecraft.tipped_arrow.effect.infested": "Mũi tên nhiễm khuẩn",
  "item.minecraft.tipped_arrow.effect.invisibility": "Mũi tên tàng hình",
  "item.minecraft.tipped_arrow.effect.leaping": "Mũi tên nhảy cao",
  "item.minecraft.tipped_arrow.effect.levitation": "Mũi tên bay lên",
  "item.minecraft.tipped_arrow.effect.luck": "Mũi tên may mắn",
  "item.minecraft.tipped_arrow.effect.mundane": "Mũi tên tẩm thuốc",
  "item.minecraft.tipped_arrow.effect.night_vision": "Mũi tên nhìn trong bóng tối",
  "item.minecraft.tipped_arrow.effect.oozing": "Mũi tên rò rỉ",
  "item.minecraft.tipped_arrow.effect.poison": "Mũi tên độc",
  "item.minecraft.tipped_arrow.effect.regeneration": "Mũi tên hồi phục",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Mũi tên rơi chậm",
  "item.minecraft.tipped_arrow.effect.slowness": "Mũi tên chậm rãi",
  "item.minecraft.tipped_arrow.effect.strength": "Mũi tên sức mạnh",
  "item.minecraft.tipped_arrow.effect.swiftness": "Mũi tên nhanh nhẹn",
  "item.minecraft.tipped_arrow.effect.thick": "Mũi tên tẩm thuốc",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Mũi tên của Rùa cụ",
  "item.minecraft.tipped_arrow.effect.water": "Mũi tên bắn nước",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Mũi tên thở dưới nước",
  "item.minecraft.tipped_arrow.effect.weakness": "Mũi tên yếu đuối",
  "item.minecraft.tipped_arrow.effect.weaving": "Mũi tên thêu dệt",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Mũi tên nạp gió",
  "item.minecraft.tnt_minecart": "Xe mỏ có TNT",
  "item.minecraft.torchflower_seeds": "Hạt hoa đuốc",
  "item.minecraft.totem_of_undying": "Vật tổ trường sinh",
  "item.minecraft.trader_llama_spawn_egg": "Trứng sinh ra Lạc đà không bướu của thương nhân",
  "item.minecraft.trial_key": "Chìa khoá thử thách",
  "item.minecraft.trident": "Đinh ba",
  "item.minecraft.tropical_fish": "Cá nhiệt đới",
  "item.minecraft.tropical_fish_bucket": "Xô cá nhiệt đới",
  "item.minecraft.tropical_fish_spawn_egg": "Trứng sinh ra Cá nhiệt đới",
  "item.minecraft.turtle_helmet": "Mai rùa",
  "item.minecraft.turtle_scute": "Vảy rùa",
  "item.minecraft.turtle_spawn_egg": "Trứng sinh ra Con rùa",
  "item.minecraft.vex_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Trang trí giáp kiểu hồn ma bay",
  "item.minecraft.vex_spawn_egg": "Trứng sinh ra Hồn ma bay",
  "item.minecraft.villager_spawn_egg": "Trứng sinh ra Dân làng",
  "item.minecraft.vindicator_spawn_egg": "Trứng sinh ra Kẻ biện hộ",
  "item.minecraft.wandering_trader_spawn_egg": "Trứng sinh ra Thương nhân lang thang",
  "item.minecraft.ward_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Trang trí giáp kiểu lộ thiên",
  "item.minecraft.warden_spawn_egg": "Trứng sinh ra Kẻ cai ngục",
  "item.minecraft.warped_fungus_on_a_stick": "Cần câu gắn nấm kì dị",
  "item.minecraft.water_bucket": "Xô nước",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Trang trí giáp kiểu người dò đường",
  "item.minecraft.wheat": "Lúa mì",
  "item.minecraft.wheat_seeds": "Hạt lúa mì",
  "item.minecraft.white_bundle": "Túi bọc trắng",
  "item.minecraft.white_dye": "Bột nhuộm trắng",
  "item.minecraft.white_harness": "Yên cương trắng",
  "item.minecraft.wild_armor_trim_smithing_template": "Mẫu rèn",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Trang trí giáp kiểu hoang dã",
  "item.minecraft.wind_charge": "Cầu gió",
  "item.minecraft.witch_spawn_egg": "Trứng sinh ra Phù thủy",
  "item.minecraft.wither_skeleton_spawn_egg": "Trứng sinh ra Bộ xương Wither",
  "item.minecraft.wither_spawn_egg": "Trứng sinh ra Wither",
  "item.minecraft.wolf_armor": "Giáp chó sói",
  "item.minecraft.wolf_spawn_egg": "Trứng sinh ra Chó sói",
  "item.minecraft.wooden_axe": "Rìu gỗ",
  "item.minecraft.wooden_hoe": "Cuốc gỗ",
  "item.minecraft.wooden_pickaxe": "Cuốc chim gỗ",
  "item.minecraft.wooden_shovel": "Xẻng gỗ",
  "item.minecraft.wooden_spear": "Giáo gỗ",
  "item.minecraft.wooden_sword": "Kiếm gỗ",
  "item.minecraft.writable_book": "Sách và bút lông",
  "item.minecraft.written_book": "Sách được viết",
  "item.minecraft.yellow_bundle": "Túi bọc vàng",
  "item.minecraft.yellow_dye": "Bột nhuộm vàng",
  "item.minecraft.yellow_harness": "Yên cương vàng",
  "item.minecraft.zoglin_spawn_egg": "Trứng sinh ra Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Trứng sinh ra Ngựa thây ma",
  "item.minecraft.zombie_nautilus_spawn_egg": "Trứng sinh ra Ốc anh vũ thây ma",
  "item.minecraft.zombie_spawn_egg": "Trứng sinh ra Thây ma",
  "item.minecraft.zombie_villager_spawn_egg": "Trứng sinh ra Dân làng thây ma",
  "item.minecraft.zombified_piglin_spawn_egg": "Trứng sinh ra Piglin thây ma"
}
export const vi_vn = items; 
